import { PoDataModel, PoItemsDataModel, PoItemsResponseModel, PoNumbersModel, PoNumbersResponseModel, PODetailViewInfoDTO, PoDetailViewResponseModel, PoVendorDataModel, AllPoResponseModel, POViewInfoDTO, PoDto, PoItemsDetails, GetItemsForSaleOrderVendor, CreatePoResponse, UpdatePoDetails, UpdatePoResponseModel, PoDetailsDto, AllPoDetailsInfo, GetAllPoResponse, PoDetailsForPoIdResponse, PoDataResponseModel, PoDataDto, PoReportDto, PoReportResponseModel, PoReportRequest, GrnQtyRequest, } from '@gtpl/shared-models/procurement-management';
import { AuthModel, EmployeeRolesEnum, SaleOrderStatusEnum, ErrorResponse, POTypeEnum, SoStatusEnum, StatusEnum, UnitRequest, GlobalStatus, MessageRequest, POLifeCycleStatusEnum, PoGrnData, PoGrnDataResDto, MessageParameters, PackingSupplierStatusEnum, GlobalVariableValues } from '@gtpl/shared-models/common-models';
import { Injectable } from '@nestjs/common';
import { InjectRepository } from '@nestjs/typeorm';
import { getManager, In, Not, Repository, TransactionManager } from 'typeorm';
import { PurchaseOrderAdapter } from './dto/po-creation.adapter';
import { PoItems } from './po-creation-items.entity';
import { PoCreation } from './po-creation.entity';
import { FoodTypeService, ItemCategoryService, ItemsService, ItemSubCategoryService, PaymentTermsService, ProductService, SizesService, SkuService, TaxesService, TypeofValueAddition4Service, TypeofValueAddition5Service, UnitcodeService, VendorsPriceListService, VendorsService } from '@gtpl/shared-services/masters'
import {  WhatsappBroadCastService } from '@gtpl/shared-services/whatsapp-broad-cast'
import { AllProductsResponseModel, ItemCategoryReq, ItemRequest, SizesDropDownDto, TaxDropDownDto, VendorDropDownDto, VendorItemRequest, PaymentTermsDropDownDto, ItemSubCategoryRequest, ItemsDropDownDto, CommonResponse, GetValueAdditionDataBySkuCodesRequest, SkuDto, ProductRequest, FoodTypeRequest, ValueAdditionIdRequest } from '@gtpl/shared-models/masters';
import { LogActions, logIntermediateObjects, LoggerInstantiation } from 'apps/services/logger/logger-functions';
import { PinoLogger } from 'nestjs-pino';
import { PurchaseOrderIdRequest } from './dto/po-id.request';
import { Cron } from '@nestjs/schedule';
import { PoItemsAdapter } from './dto/po-creation-items.adapter';
import { PoItemsRepository } from './repository/po-items.repository';
import { GrnService } from '@gtpl/shared-services/procurement';
import { PoRepository } from './repository/po-repository';
import { SOVendorRequest } from './dto/sale-order-vendor.request';
import { BomIdRequest, saleOrder, SaleOrderService } from '@gtpl/shared-services/sale-management';
import { PoDetailsDTO } from './dto/po-details-create.dto';
import { PoSaleIdRequest } from './dto/po-sale-id.request';
import { BomUpdateRequest, PoBomInfo, SaleOrderDetailViewInfoDTO, SaleOrderIdsRequest } from '@gtpl/shared-models/sale-management';
import { GenericTransactionManager } from 'apps/services/backend/typeorm-transactions/generic-transaction-manager';
import { POAdapter } from './dto/purchaser-order.adapter';
import { PoFilterData } from './dto/po-filters.dto';
import { PoBomItem } from './dto/po-bom-item.dto';
import { POCloseRequest } from './dto/po-close-request';
import { POItemIdRequest } from './dto/po-item-id.request';
import appSettings from 'apps/services/config';
import { BomIdsRequest } from './dto/bom-ids.request';
import { WhatsAppNotificationService } from '@gtpl/shared-services/notification-management';
import { whatsApp } from '../../../../whatsapp'
import { UnitIdRequest } from '../store-consumption/dto/unit-id.request';
import { PoQtyGrnDtoReqDto } from './dto/PoQtyGrnQty.dto';
import { ReportTypeENum } from '@gtpl/shared-models/analytics-data';
import { PoGrnForQty } from './dto/poGrnQty.dto';
import { VenndorIdReq } from './dto/vendor-id-req';
import { POSupplierStatus } from './dto/po-suppier-status-req';
import { BroadCastMessageRequest, WhatsAppLogDto } from "@gtpl/shared-models/whatsapp-broad-cast";
import { PoStockrequest } from './dto/po-stock.request';
import { StockRepository } from '../grn/repository/stock-repository';
// import { LogsService } from '@gtpl/shared-services/user-logs';
// import { LogsDto } from 'libs/shared-models/user-logs/src/lib/Logs/logs.dto';
const moment = require('moment');



const poTable = appSettings.procure_db + '.purchase_order';
const poItemsTable = appSettings.procure_db + '.purchase_order_items';
const soTable = appSettings.sales_db + '.sale_order';
const soInvTable = appSettings.sales_db + '.so_invoice_details';
const payTermsTable = appSettings.masters_db + '.payment_terms';
const shipTermsTable = appSettings.masters_db + '.shipping_terms';
const delTermsTable = appSettings.masters_db + '.delivery_terms';
const unitCodesTable = appSettings.masters_db + '.unitcodes';
const itemsTable = appSettings.masters_db + '.items';
const ietmSubCategoryTable = appSettings.masters_db + '.item_sub_categories';
const taxesTable = appSettings.masters_db + '.taxes';
const vendorsTable = appSettings.masters_db + '.vendors';
@Injectable()
export class PoCreationService {
    constructor(
    //   private logService:LogsService,

        @InjectRepository(PoCreation)
        private poRepository: Repository<PoCreation>,
        private vendorService: VendorsService,
        private wtsAppBroadCatService : WhatsappBroadCastService,
        private itemCategoryService: ItemCategoryService,
        private itemService: ItemsService,
        private sizeService: SizesService,
        private grnService: GrnService,
        private poRepo: PoRepository,
        private poAdapter: PurchaseOrderAdapter,
        private purchaseAdapter: POAdapter,
        private itemsAdapter: PoItemsAdapter,
        private itemsRepo: PoItemsRepository,
        private soService: SaleOrderService,
        private vendorPriceListService: VendorsPriceListService,
        private taxService: TaxesService,
        private paymentTermsService: PaymentTermsService,
        private subCategoryService: ItemSubCategoryService,
        private unitcodeService: UnitcodeService,
        private productService: ProductService,
        private foodtypeservice: FoodTypeService,
        private valAddFourService: TypeofValueAddition4Service,
        private valAddFiveService: TypeofValueAddition5Service,
        private wpService: WhatsAppNotificationService,

        // private logger: PinoLogger,

    ) { }

    async getPoDataById(poIdReq: PurchaseOrderIdRequest): Promise<PoItemsResponseModel> {

        const podata = await this.poRepo.getPoData(poIdReq.purchaseOrderId);
        const poItems: PoItemsDataModel[] = [];
        const vendorDetails = await this.vendorService.getVendorDataById({ vendorId: podata.vendorName });
        console.log(vendorDetails.data);
        // logIntermediateObjects({logger: this.logger, functionName: this.vendorService.getVendorDataById.name, loggingMode: 'trace'}, {vendorDetails});
        const vendorData = new PoVendorDataModel(podata.vendorName, vendorDetails.data.vendorCode, vendorDetails.data.vendorName, vendorDetails.data.contactPerson, vendorDetails.data.contactNumber, vendorDetails.data.street, vendorDetails.data.apartment, vendorDetails.data.city, vendorDetails.data.postalCode);


        // console.log(vendorData);
        for (const poItem of podata.poCreationItemsInfo) {
            // console.log(poItem.itemCategory)
            const itemcategorydata = await this.itemCategoryService.getItemCategoryById({ itemCategoryId: poItem.itemCategory });
            const itemSubcategorydata = await this.subCategoryService.getItemSubCategoryForId({ itemSubCategoryId: poItem.itemSubCategoryId });

            // logIntermediateObjects({logger: this.logger, functionName: this.itemCategoryService.getItemCategoryById.name, loggingMode: 'trace'}, {itemcategorydata});

            const itemdata = await this.itemService.getItemById({ itemId: poItem.itemName });
            const sizeData = await this.sizeService.getSizeDataById({ sizeId: itemdata.sizeId });
            const taxData = await this.taxService.getTaxForId({ taxId: poItem.taxPer });
            // const sizeData = new SizesDropDownDto(1,'5*2');

            const QtyData = await this.grnService.getGrnQtyByPoId({ purchaseOrderId: poIdReq.purchaseOrderId, itemCategoryId: poItem.itemCategory, itemId: poItem.itemName, saleOrderId: poItem.saleOrderId });
            // console.log('show')
            console.log(QtyData)

            // logIntermediateObjects({logger: this.logger, functionName: this.itemService.getItemById.name, loggingMode: 'trace'}, {itemdata});
            let soNumber
            let poNumber
            let soStatus = 'OPEN';
            if (poItem.saleOrderId > 0) {
                const soData = await this.soService.getSaleOrderFewDetailsForSoId({ saleOrderId: poItem.saleOrderId })
                soNumber = soData.saleOrderNumber;
                poNumber = soData.poNumber;
                soStatus = soData.status;
            } else {
                soNumber = 'N/A'
                poNumber = ''
            }

            const poItemObject = new PoItemsDataModel(
                poItem.purchaseOrderItemId,
                poIdReq.purchaseOrderId,
                itemcategorydata,
                itemdata,
                sizeData?sizeData:null,
                poItem.itemQuantity,
                poItem.itemCost,
                poItem.discount,
                poItem.tax,
                poItem.subAmount,
                taxData,
                poItem.discountPer,
                QtyData.data.grnQty,
                poItem.receivedQuantity,
                poItem.transportation,
                poItem.saleOrderId,
                soNumber,
                itemSubcategorydata,
                poNumber,
                soStatus,
                false
            )
            poItems.push(poItemObject);
        }
        // console.log(poItems);

        const PodataModel = new PoDataModel(podata.purchaseOrderId, podata.saleOrderId, vendorData, podata.totalQuantity, podata.totalBasicPrice, podata.totalDiscount, podata.totalTax, podata.totalCost, poItems, podata.plantAddress)
        // console.log(PodataModel);
        const response = new PoItemsResponseModel(true, 1108, ' po Details Retrieved Succesfully', PodataModel);
        return response;
    }


    async getAllPoDetails() {
        // try {
        //     const poDto: PoDto[] = [];
        //     // retrieves all pos
        //     const poEntities: PoCreation[] = await this.poRepository.find({
        //         order: { createdAt: "DESC" },
        //     });
        //     if (poEntities.length > 0) {
        //         for (const eachItem of poEntities) {
        //             const saleOrderId = this.soService.getSaleorderDataById({ saleOrderId: eachItem.saleOrderId });
        //             const vendorId = this.vendorService.getVendorDataById({ vendorId: eachItem.vendorName });

        //             await Promise.all([saleOrderId, vendorId]).then(res => {
        //                 const saleOrder = res[0].status ? res[0].data.saleOrderNumber : null;
        //                 const vendor = res[1].status ? res[1].data.vendorName : null;
        //                 const poObject = new PoDto(
        //                     vendor,
        //                     saleOrder,
        //                     eachItem.purchaseOrderDate,
        //                     eachItem.totalTransportation,
        //                     eachItem.expectedDeliveryDate,
        //                     eachItem.deliveryAddress,
        //                     eachItem.paymentTerms,
        //                     eachItem.remarks,
        //                     eachItem.note,
        //                     eachItem.createdUser,
        //                     eachItem.updatedUser,
        //                     eachItem.poCreationItemsInfo,
        //                     eachItem.purchaseOrderId,
        //                     eachItem.poNumber,
        //                     eachItem.status,
        //                 );
        //                 poDto.push(poObject)
        //             })
        //         }
        //         console.log(poDto);
        //         const response = new AllPoResponseModel(true, 11208, "POs retrieved successfully", poDto);
        //         return response;
        //     } else {
        //         throw new ErrorResponse(99998, 'No Records Found');
        //     }
        // } catch (err) {
        //     console.log(err);
        //     throw err;
        // }
    }



    /**
  * gets all item category details  
  * @returns all item category details .
  */
    async getPoNumbers(): Promise<PoNumbersResponseModel> {
        const poDTO: PoNumbersModel[] = [];
        const itemCategoryEntities: PoNumbersModel[] = await this.poRepository.find({
            select: ['purchaseOrderId', 'poNumber'],
            where: { status: In([StatusEnum.OPEN, StatusEnum.IN_PROGRESS]) },
            order: { 'createdAt': 'DESC' }
        });
        if (itemCategoryEntities && itemCategoryEntities.length > 0) {
            itemCategoryEntities.forEach(itemCatEntity => {
                poDTO.push(new PoNumbersModel(itemCatEntity.purchaseOrderId, itemCatEntity.poNumber));
            });
            const response = new PoNumbersResponseModel(true, 11108, "PO Numbers retrieved successfully", poDTO);
            return response;
        } else {
            throw new ErrorResponse(99998, 'Data not found');
        }
    }

    async getPoNumbersByVendor(req: BomIdsRequest): Promise<PoNumbersResponseModel> {
        console.log('reqee')
        console.log(req)
        const poDTO: PoNumbersModel[] = [];
        const itemCategoryEntities: PoNumbersModel[] = await this.poRepository.find({
            select: ['purchaseOrderId', 'poNumber'],
            where: { status: In([StatusEnum.OPEN, StatusEnum.IN_PROGRESS]), vendorName: req.vendorId },
            order: { 'createdAt': 'DESC' }
        });
        if (itemCategoryEntities && itemCategoryEntities.length > 0) {
            itemCategoryEntities.forEach(itemCatEntity => {
                poDTO.push(new PoNumbersModel(itemCatEntity.purchaseOrderId, itemCatEntity.poNumber));
            });
            const response = new PoNumbersResponseModel(true, 11108, "PO Numbers retrieved successfully", poDTO);
            return response;
        } else {
            throw new ErrorResponse(99998, 'Data not found');
        }
    }


    async CreatePo(poData: PoDetailsDto, isUpdate?: boolean): Promise<CreatePoResponse> {
        const today = new Date();
        const CurrentYear = today.getFullYear();
        const CurrentMonth = today.getMonth();
        let fromDate = 0;
        let toDate = 0;
        let totalPO = await this.poRepo.count();
        if (!isUpdate) {
            if (CurrentMonth < 4) {
                fromDate = (CurrentYear);
                toDate = (CurrentYear + 1);
            } else {
                fromDate = (CurrentYear);
                toDate = (CurrentYear + 1);
            }

        }
        const vendorDetails = await this.vendorService.getVendorDataById({ vendorId: poData.vendorId });

        totalPO = totalPO + 1;

        let refNo = totalPO + "";
        while (refNo.length < 4) refNo = "0" + refNo;

        const currentFinancialYear = "PO" + (fromDate.toString().substr(-2)) + "/" + vendorDetails.data.vendorCode + "/" + refNo;
        // convert dto to entity
        //po 
        const poEntity = this.poAdapter.convertDtoToEntity(poData, currentFinancialYear, isUpdate);
        const createResponse = await this.poRepo.save(poEntity);

        const conItems: PoItems[] = [];
        for (const poItems of poData.poItems) {
            const itemsEntity = await this.itemsAdapter.convertDtoToEntity(poItems, createResponse.purchaseOrderId);

            const createItems = await this.itemsRepo.save(itemsEntity);
            if (createItems.bomItemId) {
                const bomReq = new BomIdRequest(createItems.bomItemId, true, poItems.quantity)
                const updateBomStatus = await this.soService.updateBomStats(bomReq)
                // if(updateBomStatus.status){
                //     const updatePackingBOM = await this.soService.updatePackingBOM(new BomUpdateRequest(poItems.item,poItems.saleOrderId,poItems.quantity,undefined));
                // }
            }

        }

        if (poData.saleOrderId) {
            // update so 
            const soReq: saleOrder = {
                saleOrderId: poData.saleOrderId
            }

            const updateSo = await this.soService.UpdateSoForPo(soReq);
        }


        if (createResponse) {
            const repo = new CreatePoResponse(true, 1111, 'Created Successfully', 'Created Successfully');
            // const name=isUpdate?'updated':'created'
            
            // const newLogDto = new LogsDto(1,'Po created', 'PoCreation', createResponse.purchaseOrderId, true, '',createResponse.createdUser)
            // let res = await this.logService.createLog(newLogDto);
            // console.log(res);
            return repo
        } else {
            throw new ErrorResponse(9999, 'Failed To Create')
        }


    }

    async closePOManually(poIdReq: POCloseRequest): Promise<CommonResponse> {
        const manager = new GenericTransactionManager();
        try {
            if (poIdReq) {
                await manager.startTransaction();
                // update po status as closed
                const updatePOStatus = await manager.getCustomRepository(PoRepository).update({ purchaseOrderId: poIdReq.purchaseOrderId }, { status: StatusEnum.CLOSED, reasonClosing: poIdReq.reasonClosing });

                //if updated po status as close so, bom packing status
                if (updatePOStatus.affected) {
                    const getPO = await this.poRepository.findOne({ where: { purchaseOrderId: poIdReq.purchaseOrderId }, relations: ['poCreationItemsInfo'] });
                    if (getPO.poCreationItemsInfo && getPO.poCreationItemsInfo.length) {
                        for (const item of getPO.poCreationItemsInfo) {
                            const soReq: saleOrder = {
                                saleOrderId: item.saleOrderId
                            }
                            const updateSo = await this.soService.UpdateSoForPo(soReq);
                        }
                    }
                    manager.completeTransaction();
                    const close = new CommonResponse(true, 11111, 'PO Closed Successfully');
            //          const newLogDto = new LogsDto(1,'Close Po', 'PoCreation', 0, true, '','')
            // let res = await this.logService.createLog(newLogDto);
            // console.log(res);
            return close
                } else {
                    throw new ErrorResponse(9999, 'Failed To Close PO');
                }
            } else {
                throw new ErrorResponse(9999, 'Failed To Close PO')
            }
        } catch (error) {
            await manager.releaseTransaction();
            return error;
        }

    }

    async CreatePurchaseOrder(poData: PoDetailsDto, isUpdate?: boolean): Promise<CreatePoResponse> {
        const manager = new GenericTransactionManager();
        try {
            // get form plant name 
            // const plantDetails = await this.unitcodeService.getPlantDetailsById({ unitcodeId: poData.unitId });
            // const plant = plantDetails.status ? plantDetails.data.plantCode : "";


            const today = new Date();
            const CurrentYear = today.getFullYear();
            const CurrentMonth = today.getMonth();
            console.log(CurrentMonth,'CurrentMonth')
            let fromDate = 0;
            let toDate = 0;
            let totalPOQry = await this.poRepo.find({
                order:{purchaseOrderId:'DESC'},
                take:1
            })
            let totalPO = Number(totalPOQry[0].purchaseOrderId)
            console.log(totalPO,'totalPo')
            console.log(totalPOQry[0].purchaseOrderId,'totalPoff')
            console.log(CurrentYear,'CurrentYear')

            if (!isUpdate) {
                if ((CurrentMonth+1) < 4) {
                    fromDate = (CurrentYear-1);
                    toDate = (CurrentYear);
                } else {
                    fromDate = (CurrentYear);
                    toDate = (CurrentYear + 1);
                }

            }
            const vendorDetails = await this.vendorService.getVendorDataById({ vendorId: poData.vendorId });

            totalPO = totalPO + 1;

            let refNo = totalPO + "";
            while (refNo.length < 4) refNo = "0" + refNo;

            const currentFinancialYear = "PO" + (fromDate.toString().substr(-2)) + "/" + vendorDetails.data.vendorCode + "/" + refNo;
            console.log(fromDate,'fromDate')
            // convert dto to entity
            await manager.startTransaction();
            const poEntity = this.purchaseAdapter.convertDtoToEntity(poData, currentFinancialYear);
            const createResponse = await manager.getCustomRepository(PoRepository).save(poEntity);
            console.log(createResponse);
            if (createResponse) {
                if (poData.poType == POTypeEnum.WITHSO) {
                    const bomItems: PoBomItem[] = [];
                    for (const poItems of createResponse.poCreationItemsInfo) {
                        if (poItems.bomItemId && poItems.isActive) {
                            const getPoQty = await manager.getCustomRepository(PoItemsRepository).createQueryBuilder('po').select('sum(item_quantity) as item_quantity').where(`bom_item_id=${poItems.bomItemId} and item_name=${poItems.itemName} and status=1`).getRawOne();

                            const bomReq = new BomIdRequest(poItems.bomItemId, true, getPoQty.item_quantity,false,poItems.itemName)
                            const updateBomStatus = await this.soService.updateBomStats(bomReq);
                            if (updateBomStatus.status) {
                                const updatePackingBOM = await this.soService.updatePackingBOM(new BomUpdateRequest(poItems.itemName, poItems.saleOrderId, poItems.itemQuantity, undefined));
                            }
                            if (!updateBomStatus.status) {
                                throw new ErrorResponse(9999, 'Failed To Update Bom')
                            }

                            // update so 
                            const soReq: saleOrder = {
                                saleOrderId: poItems.saleOrderId
                            }
                            const updateSo = await this.soService.UpdateSoForPo(soReq);
                            if (!updateSo.status) {
                                throw new ErrorResponse(9999, 'Failed To update Saleorder')
                            }
                        } else {
                            if (poItems.isActive) {
                                const itemData = await this.itemService.getItemById({ itemId: poItems.itemName });
                                const rmBomObj = new PoBomItem();
                                rmBomObj.itemId = poItems.itemName;
                                rmBomObj.saleOrderId = poItems.saleOrderId;
                                rmBomObj.itemCategoryId = poItems.itemCategory;
                                rmBomObj.itemSubCategoryId = poItems.itemSubCategoryId;
                                rmBomObj.quantity = poItems.itemQuantity;
                                rmBomObj.sizeId = itemData?.sizeId;
                                rmBomObj.createdUser = poData.createdUser
                                const items = new PoBomInfo();
                                items.bomItems = [rmBomObj];
                                const bomSaveResponse = await this.soService.savePoBomItems(items);

                                if (!bomSaveResponse.status) {
                                    throw new ErrorResponse(9999, 'Failed while adding items to bom');
                                }
                                else {
                                    for (const updatePOItem of bomSaveResponse.data) {
                                        const updatePOBomId = await manager.getCustomRepository(PoItemsRepository).update({ purchaseOrderItemId: poItems.purchaseOrderItemId }, { bomItemId: updatePOItem.packingMaterialId, fromPo: true });
                                        if (!updatePOBomId.affected) {
                                            throw new ErrorResponse(9999, 'Failed while adding items to bom');
                                        }
                                    }
                                }
                            }

                        }
                    }

                }

                manager.completeTransaction();
                const repo = new CreatePoResponse(true, 1111, 'Created Successfully', 'Created Successfully');
                // const newLogDto = new LogsDto(1,'created', 'PoCreation', createResponse.purchaseOrderId, true, '',createResponse.createdUser)
                // let res = await this.logService.createLog(newLogDto);
                // console.log(res);
                return repo
            } else {
                throw new ErrorResponse(9999, 'Failed To Create');
            }
        } catch (error) {
            await manager.releaseTransaction();
            return error;
        }

    }

    async deletePoItem(req: POItemIdRequest): Promise<CommonResponse> {
        const manager = new GenericTransactionManager();
        try {
            await manager.startTransaction();
            const itemInfo = await manager.getCustomRepository(PoItemsRepository).createQueryBuilder('po').select('bom_item_id as bomItemId, item_quantity as itemQuantity').where(`purchase_order_items_id=${req.poItemId}`).getRawOne();

            const updateResponse = await manager.getCustomRepository(PoItemsRepository).update({ purchaseOrderItemId: req.poItemId }, { isActive: false });
            if (updateResponse.affected) {
                if (itemInfo.bomItemId) {
                    const bomReq = new BomIdRequest(itemInfo.bomItemId, false, itemInfo.itemQuantity, true);
                    const bomItemResonse = await this.soService.ActivateorDeactivateBom(bomReq);
                    if (!bomItemResonse.status) {
                        throw new ErrorResponse(9999, 'Failed To Delete Bom Item');
                    }
                }
                await manager.completeTransaction();
                return new CommonResponse(true, 1111, 'removed item from po')
            } else {
                throw new ErrorResponse(9999, 'Failed To Delete');
            }
        } catch (error) {
            await manager.releaseTransaction();
            return error
        }
    }


    async getPODataById(poReq: PurchaseOrderIdRequest) {

        // try {
        //     const poEntities: PoCreation = await this.poRepository.findOne({
        //         where: { purchaseOrderId: poReq.purchaseOrderId }
        //     });
        //     if (poEntities) {
        //         const saleOrderId = this.soService.getSaleorderDataById({ saleOrderId: poEntities.saleOrderId });
        //         const vendorId = this.vendorService.getVendorDataById({ vendorId: poEntities.vendorName });



        //         return await Promise.all([saleOrderId, vendorId]).then(res => {
        //             const saleOrder = res[0].status ? res[0].data.saleOrderNumber : null;
        //             const vendor = res[1].status ? res[1].data.vendorName : null;
        //             const poObject = new PoDto(
        //                 vendor,
        //                 saleOrder,
        //                 poEntities.purchaseOrderDate,
        //                 poEntities.totalTransportation,
        //                 poEntities.expectedDeliveryDate,
        //                 poEntities.deliveryAddress,
        //                 poEntities.paymentTerms,
        //                 poEntities.remarks,
        //                 poEntities.note,
        //                 poEntities.createdUser,
        //                 poEntities.updatedUser,
        //                 poEntities.poCreationItemsInfo,
        //                 poEntities.purchaseOrderId,
        //                 poEntities.poNumber,
        //                 poEntities.status,
        //             );
        //             console.log(poObject);
        //             const response = new PoDetailViewResponseModel(true, 11208, "PO details retrieved successfully", poObject);
        //             return response;
        //         })

        //     } else {
        //         throw new ErrorResponse(99998, 'No Records Found');
        //     }
        // }
        // catch (err) {
        //     console.log(err);
        //     throw err;
        // }
    }


    async GetItemsForSaleOrderVendor(soVendorReq: SOVendorRequest, auth?: AuthModel): Promise<GetItemsForSaleOrderVendor> {

        // get so bom items for so ids 
        const soReq = new SaleOrderIdsRequest(soVendorReq.saleOrderId);
        const soDetails = await this.soService.getAllBomDetailsForSoIdInPo(soReq);
        if (soDetails.status && soDetails.data.length) {
            const poItems: PoItemsDetails[] = [];
            for (const bomItem of soDetails.data) {
                // get item price and tax for vendor id and item id
                const vendorItemReq = new VendorItemRequest(soVendorReq.vendorId, bomItem.itemDetails.itemId);

                const itemsResponse = await this.vendorPriceListService.GetItemPriceTaxForVendorIdItemId(vendorItemReq);
                const defaultTax = await this.taxService.getTaxForNoTax();
                let itemPriceTaxDetails
                if (itemsResponse.status) {
                    itemPriceTaxDetails = itemsResponse.data
                    const taxData = new TaxDropDownDto(itemPriceTaxDetails.taxes.taxId, itemPriceTaxDetails.taxes.taxName, itemPriceTaxDetails.taxes.taxPercentage)

                    let taxAmount = 0;
                    const discountPercentage = 0;
                    const discountAmount = 0;
                    const transportation = 0;
                    let Amount = 0;
                    taxAmount = Number(((itemPriceTaxDetails.unitPrice * bomItem.quantity) * (itemPriceTaxDetails.taxes.taxPercentage / 100)).toFixed(3));

                    Amount = (itemPriceTaxDetails.unitPrice * bomItem.quantity) + taxAmount;
                    const poItem = new PoItemsDetails(bomItem.itemCategoryDetails, bomItem.itemSubCategoryDetails, bomItem.itemDetails, bomItem.size, bomItem.quantity, itemPriceTaxDetails.unitPrice, (taxData) ? taxData : defaultTax, taxAmount, discountPercentage, discountAmount, transportation, Amount, bomItem.packingMaterialId, 0, 0, bomItem.saleOrderId, bomItem.saleOrderNumber, '', false, true, bomItem.avilableQuantity);
                    poItems.push(poItem);
                }
                else {
                    const poItem = new PoItemsDetails(bomItem.itemCategoryDetails, bomItem.itemSubCategoryDetails, bomItem.itemDetails, bomItem.size, bomItem.quantity, 0, defaultTax, 0, 0, 0, 0, 0, bomItem.packingMaterialId, 0, 0, bomItem.saleOrderId, bomItem.saleOrderNumber, '', false, true, bomItem.avilableQuantity);
                    poItems.push(poItem);
                }
            }
            return new GetItemsForSaleOrderVendor(true, 1111, (poItems.length) ? 'Po Items Data Found Successfully' : 'Items Price List Not Updated For Selected Vendor', poItems);
        } else {
            return new GetItemsForSaleOrderVendor(false, 9999, soDetails.internalMessage);
        }
    }


    async GetItemsForBomVendor(bomVendorReq: BomIdsRequest, auth?: AuthModel): Promise<GetItemsForSaleOrderVendor> {

        // get so bom items for so ids 
        const soReq = new BomIdsRequest(bomVendorReq.packingMaterialId, bomVendorReq.vendorId, bomVendorReq.unitId);
        const soDetails = await this.soService.GetItemsForBomVendor(soReq);
        if (soDetails.status && soDetails.data.length) {
            const poItems: PoItemsDetails[] = [];
            for (const bomItem of soDetails.data) {
                // get item price and tax for vendor id and item id
                const vendorItemReq = new VendorItemRequest(bomVendorReq.vendorId, bomItem.itemDetails.itemId);

                const itemsResponse = await this.vendorPriceListService.GetItemPriceTaxForVendorIdItemId(vendorItemReq);
                const defaultTax = await this.taxService.getTaxForNoTax();
                let itemPriceTaxDetails
                if (itemsResponse.status) {
                    itemPriceTaxDetails = itemsResponse.data
                    const taxData = new TaxDropDownDto(itemPriceTaxDetails.taxes.taxId, itemPriceTaxDetails.taxes.taxName, itemPriceTaxDetails.taxes.taxPercentage)

                    let taxAmount = 0;
                    const discountPercentage = 0;
                    const discountAmount = 0;
                    const transportation = 0;
                    let Amount = 0;
                    taxAmount = Number(((itemPriceTaxDetails.unitPrice * bomItem.quantity) * (itemPriceTaxDetails.taxes.taxPercentage / 100)).toFixed(3));

                    Amount = (itemPriceTaxDetails.unitPrice * bomItem.quantity) + taxAmount;
                    const poItem = new PoItemsDetails(bomItem.itemCategoryDetails, bomItem.itemSubCategoryDetails, bomItem.itemDetails, bomItem.size, bomItem.quantity, itemPriceTaxDetails.unitPrice, (taxData) ? taxData : defaultTax, taxAmount, discountPercentage, discountAmount, transportation, Amount, bomItem.packingMaterialId, 0, 0, bomItem.saleOrderId, bomItem.saleOrderNumber, '', false, bomItem.isActive);
                    poItems.push(poItem);
                }
                else {
                    const poItem = new PoItemsDetails(bomItem.itemCategoryDetails, bomItem.itemSubCategoryDetails, bomItem.itemDetails, bomItem.size, bomItem.quantity, 0, defaultTax, 0, 0, 0, 0, 0, bomItem.packingMaterialId, 0, 0, bomItem.saleOrderId, bomItem.saleOrderNumber, '', false, bomItem.isActive);
                    poItems.push(poItem);
                }
            }

            return new GetItemsForSaleOrderVendor(true, 1111, (poItems.length) ? 'Po Items Data Found Successfully' : 'Items Price List Not Updated For Selected Vendor', poItems);
        } else {
            return new GetItemsForSaleOrderVendor(false, 9999, soDetails.internalMessage);
        }
    }


    async GetPurchaseOrderDetailsForPoId(poIdReq: PurchaseOrderIdRequest): Promise<UpdatePoResponseModel> {
        const podata = await this.poRepo.getPoDataForPoDetailView(poIdReq.purchaseOrderId);
        const poItems: PoItemsDetails[] = [];
        console.log(podata,'poData>>>');
        if (podata) {
            for (const poItem of podata.poCreationItemsInfo) {

                const itemCategoryData = await this.itemCategoryService.getItemCategoryById({ itemCategoryId: poItem.itemCategory });
                const itemData = await this.itemService.getItemById({ itemId: poItem.itemName });
                // const sizeData = await this.sizeService.getSizeDataById({ sizeId: poItem.size });
                const taxData = await this.taxService.getTaxForId({ taxId: poItem.taxPer });
                const defaultTax = await this.taxService.getTaxForNoTax();
                const itemSubCategoryReq = new ItemSubCategoryRequest(poItem.itemSubCategoryId);
                // get item sub category details for item sub category id
                const itemSubCategoryDetails = await this.subCategoryService.getItemSubCategoryForId(itemSubCategoryReq);

                let soNo = '';
                let coNo = '';
                console.log(poItem.saleOrderId,'saleOrder??')
                if (poItem.saleOrderId) {
                    const soReq: saleOrder = {
                        saleOrderId: poItem.saleOrderId
                    }
                    const saleOrderDetails = await this.soService.getSaleOrderDetailsForId(soReq);
                    soNo = saleOrderDetails.saleOrderNumber;
                    coNo = saleOrderDetails.poNumber;
                    console.log(saleOrderDetails)
                }

                // taxData.taxName = taxData.taxName + " - " + taxData.taxPercentage
                const poItemObject = new PoItemsDetails(
                    itemCategoryData,
                    itemSubCategoryDetails,
                    itemData,
                    null,
                    poItem.itemQuantity,
                    poItem.itemCost,
                    taxData ? taxData : defaultTax,
                    poItem.tax,
                    poItem.discountPer,
                    poItem.discount,
                    poItem.transportation,
                    poItem.subAmount,
                    poItem.bomItemId,
                    poItem.purchaseOrderId,
                    poItem.purchaseOrderItemId,
                    poItem.saleOrderId,
                    soNo + " - " + coNo,
                    coNo,
                    poItem.fromPo,
                    poItem.isActive
                )
                poItems.push(poItemObject);
            }

            const PodataModel = new UpdatePoDetails(podata.vendorName, podata.saleOrderId, podata.purchaseOrderDate, podata.totalTransportation, podata.expectedDeliveryDate, Number(podata.deliveryAddress), podata.paymentTerms, podata.remarks, podata.note, podata.exchangeRate, podata.createUser, podata.updatedUser, poItems, podata.poType, podata.purchaseOrderId, Number(podata.billingAddress), podata.shippingTerms, podata.deliveryTerms, podata.plantAddress);

            const response = new UpdatePoResponseModel(true, 1108, 'po Details Retrieved Successfully', PodataModel);
            return response;
        } else {
            throw new ErrorResponse(9999, 'Failed to Get Po Details')
        }

    }

    async getAllPoDetailsInfo(req?: PoFilterData): Promise<GetAllPoResponse> {

        const manager = getManager();
        let trackerQuery = `SELECT po_type as poType, GROUP_CONCAT(s.sale_order_no," ") AS soNumber, GROUP_CONCAT(inv.po_number, " ") AS poNumber, po.po_number as purchaseOrderNo, purchase_order_date as purchaseOrderDate, v.vendor_name as vendorName, expected_delivery_date as expectedDeliveryDate, po.status, po.purchase_order_id as purchaseOrderId,u.unit_name , po.max_grn_date as grnDate FROM ` + appSettings.procure_db + `.purchase_order po 
        LEFT JOIN ` + appSettings.procure_db + `.purchase_order_items pi ON pi.purchase_order_id=po.purchase_order_id 
        LEFT JOIN ` + appSettings.sales_db + `.sale_order s ON s.sale_order_id=pi.sale_order_id 
        LEFT JOIN ` + appSettings.sales_db + `.so_invoice_details inv ON inv.sale_order_id=s.sale_order_id 
        LEFT JOIN ` + appSettings.masters_db + `.vendors v ON v.vendor_id=po.vendor_name
        LEFT JOIN ` + appSettings.masters_db + `.unitcodes u ON u.unit_code_id=po.plant_address where pi.status = 1`;
        if ((([
            EmployeeRolesEnum.ADMIN,
            EmployeeRolesEnum.HO_PACKAGING_MANAGER
        ].indexOf(req.role)) === -1) && req.fromDate && req.toDate) {
            trackerQuery += ` and delivery_address= ${req.unitId} Date(expected_delivery_date) between '${moment(req.fromDate).format("YYYY-MM-DD")}' and '${moment(req.toDate).format("YYYY-MM-DD")}'`
        }

        if ((([
            EmployeeRolesEnum.ADMIN,
            EmployeeRolesEnum.HO_PACKAGING_MANAGER
        ].indexOf(req.role)) === -1) && !(req.fromDate && req.toDate)) {
            trackerQuery += ` and delivery_address= ${req.unitId}`;
        }

        if (!(([
            EmployeeRolesEnum.ADMIN,
            EmployeeRolesEnum.HO_PACKAGING_MANAGER
        ].indexOf(req.role)) === -1) && (req.fromDate && req.toDate)) {
            trackerQuery += ` and Date(expected_delivery_date) between '${moment(req.fromDate).format("YYYY-MM-DD")}' and '${moment(req.toDate).format("YYYY-MM-DD")}'`;
        }
        if (req.unitId && req.unitId != 5) {
            trackerQuery += ` and po.plant_address=` + req.unitId;
        }
        trackerQuery += ` group by po.purchase_order_id`;

        const poData: AllPoDetailsInfo[] = await manager.query(trackerQuery);

        if (poData && poData.length > 0) {
            const resu = new GetAllPoResponse(true, 1525, 'Po Details Retrieved Successfully', poData);
            // const newLogDto = new LogsDto(1,'view po details', 'PoCreation', 0, true, '','')
            // let res = await this.logService.createLog(newLogDto);
            // console.log(res);
            return resu
        } else {
            throw new ErrorResponse(9999, 'No Data Found');
        }
    }


    async getAllPoDetailsInfoOld(req?: PoFilterData): Promise<GetAllPoResponse> {
        const poEntities = this.poRepo.createQueryBuilder('PoCreation')
            .leftJoinAndSelect('PoCreation.poCreationItemsInfo', 'poCreationItemsInfo')
        // .where(`unit_id=${req.unitId}`);

        if (req.fromDate && req.toDate) {
            poEntities.andWhere(`Date(expected_delivery_date) between '${moment(req.fromDate).format("YYYY-MM-DD")}' and '${moment(req.toDate).format("YYYY-MM-DD")}'`);
        }

        if ((([
            EmployeeRolesEnum.ADMIN,
            EmployeeRolesEnum.HO_PACKAGING_MANAGER
        ].indexOf(req.role)) === -1)) {
            poEntities.andWhere(`delivery_address= ${req.unitId}`);
        }
        const poData: PoCreation[] = await poEntities.getMany();

        if (poData && poData.length > 0) {
            const poInfo: AllPoDetailsInfo[] = [];
            for (const po of poData) {
                let saleOrderDetails: any = '';
                const vendorDetails = await this.vendorService.getVendorDataById({ vendorId: po.vendorName });

                const vendor = new VendorDropDownDto(vendorDetails.data.vendorId, vendorDetails.data.vendorName);

                const paymentTermsDetails = await this.paymentTermsService.getPaymentById({ paymentTermsId: po.paymentTerms })

                let paymentTermsName = '';
                if (paymentTermsDetails.status) {
                    paymentTermsName = paymentTermsDetails.data.paymentTermsName;
                }

                const sos = [];
                const poNumbers = [];
                let uniqSo = [];
                let uniqPO = [];
                for (const poItem of po.poCreationItemsInfo) {
                    if (poItem.saleOrderId && poItem.isActive) {
                        const soReq: saleOrder = {
                            saleOrderId: poItem.saleOrderId
                        }
                        saleOrderDetails = await this.soService.getSaleOrderDetailsForId(soReq);
                        sos.push(saleOrderDetails.saleOrderNumber);
                        poNumbers.push(saleOrderDetails.poNumber);
                    }

                }
                uniqSo = [...new Set(sos)];
                uniqPO = [...new Set(poNumbers)];
                const poData = new AllPoDetailsInfo(saleOrderDetails, vendor, po.poNumber, po.purchaseOrderDate, po.totalTransportation, po.expectedDeliveryDate, po.deliveryAddress, po.paymentTerms, po.remarks, po.note, po.createdUser, po.updatedUser, null, po.purchaseOrderId, po.status, po.poType, '', uniqSo.toString(), uniqPO.toString());
                poInfo.push(poData);
            }
            return new GetAllPoResponse(true, 1525, 'Po Details Retrieved Successfully', poInfo);
        } else {
            throw new ErrorResponse(9999, 'No Data Found');
        }
    }

    async getPoDetailsForSaleId(poSaleIdReq: PoSaleIdRequest): Promise<PoDataResponseModel> {
        try {
            const poEntity = await this.poRepo.findOne({
                where: { saleOrderId: poSaleIdReq.saleOrderId }
            });
            console.log(poEntity != undefined);
            if (poEntity != undefined) {
                const poData = new PoDataDto(poEntity.purchaseOrderDate, poEntity.poNumber);
                return new PoDataResponseModel(true, 1111, 'Po Details Retrieved SuccessFully', poData)
            }
            else {
                throw new ErrorResponse(9999, 'No Data Found');
            }
        } catch (error) {
            console.log(error);

            throw error;
        }
    }

    async getPoItemDetailsForSaleId(poSaleIdReq: PoSaleIdRequest): Promise<CommonResponse> {
        try {
            const poEntity = await this.itemsRepo.find({
                where: { saleOrderId: poSaleIdReq.saleOrderId }
            });
            console.log(poEntity != undefined);
            if (poEntity.length > 0) {
                return new CommonResponse(true, 1111, 'Po Details Retrieved SuccessFully')
            }
            else {
                throw new CommonResponse(false, 9999, 'No Data Found');
            }
        } catch (error) {
            console.log(error);

            throw error;
        }
    }

    async GetPoDataDetailsForPoId(poIdReq: PurchaseOrderIdRequest): Promise<PoDetailsForPoIdResponse> {
        const podata = await this.poRepo.getPoDataForPoDetailView(poIdReq.purchaseOrderId);
        if (podata) {

            // get payment terms
            const getPaymentDetails = await this.paymentTermsService.getPaymentById({ paymentTermsId: podata.paymentTerms });

            let paymentTermsName = '';
            if (getPaymentDetails.status) {
                paymentTermsName = getPaymentDetails.data.paymentTermsName;
            }

            // get plant info 
            const plantDetails = await this.unitcodeService.getPlantDetailsById({ unitcodeId: podata.unitId });

            const deliveryPlantDetails = await this.unitcodeService.getPlantDetailsById({ unitcodeId: podata.deliveryAddress });
            const billingPlantDetails = await this.unitcodeService.getPlantDetailsById({ unitcodeId: podata.billingAddress });
            const vendorDetails = await this.vendorService.getVendorDataById({ vendorId: podata.vendorName });
            const vendor = new VendorDropDownDto(vendorDetails.data.vendorId, vendorDetails.data.vendorName, vendorDetails.data.currencyName, vendorDetails.data.priceNeeded);

            const paymentTermsDetails = await this.paymentTermsService.getPaymentById({ paymentTermsId: podata.paymentTerms })

            const poItems: PoItemsDetails[] = [];
            for (const poItem of podata.poCreationItemsInfo) {
                let saleOrderDetails = null;
                let productInfo = null;
                let foodTypeInfo = null;
                let valAddFourInfo = null;
                let valAddFiveInfo = null;

                if (poItem.saleOrderId) {
                    const soReq: saleOrder = {
                        saleOrderId: poItem.saleOrderId
                    }
                    saleOrderDetails = await this.soService.getSaleOrderDetailsForId(soReq);

                }

                const itemCategoryData = await this.itemCategoryService.getItemCategoryById({ itemCategoryId: poItem.itemCategory });
                const itemData = await this.itemService.getTotalItemDataById({ itemId: poItem.itemName });
                console.log(itemData, 'itemData')
                if (itemData?.data?.productId) {

                    const productReq = new ProductRequest(itemData?.data?.productId)
                    productInfo = await this.productService.getActiveProductById(productReq)
                } if (itemData?.data?.foodTypeId) {
                    const foodtypeReq = new FoodTypeRequest(itemData.data.foodTypeId)
                    foodTypeInfo = await this.foodtypeservice.getFoodTypeDataById(foodtypeReq);
                }
                if (itemData?.data?.valueAdditionFourId) {
                    const valAddFourReq = new ValueAdditionIdRequest()
                    valAddFourReq.valueAdditionId = itemData?.data?.valueAdditionFourId;
                    valAddFourInfo = await this.valAddFourService.getValAddDetails(valAddFourReq)
                }
                if (itemData?.data?.valueAdditionFiveId) {
                    const valAddFiveReq = new ValueAdditionIdRequest()
                    valAddFiveReq.valueAdditionId = itemData?.data?.valueAdditionFiveId;
                    valAddFiveInfo = await this.valAddFiveService.getValAddDetails(valAddFiveReq)
                }
                const itemInfo = new ItemsDropDownDto(itemData?.data?.itemId, itemData?.data?.itemName, itemData?.data?.sizeName, 0, [], productInfo ? productInfo.data.productName : '', foodTypeInfo ? foodTypeInfo.data.foodType : '', valAddFourInfo ? valAddFourInfo.data.valueAdditionIdName : '', valAddFiveInfo ? valAddFiveInfo.data.valueAdditionIdName : '');

                // const sizeData = await this.sizeService.getSizeDataById({ sizeId: poItem.size });

                const taxData = await this.taxService.getTaxForId({ taxId: poItem?.taxPer });
                const itemSubCategoryReq = new ItemSubCategoryRequest(poItem?.itemSubCategoryId);
                // get item sub category details for item sub category id
                const itemSubCategoryDetails = await this.subCategoryService.getItemSubCategoryForId(itemSubCategoryReq);


                const poItemObject = new PoItemsDetails(
                    itemCategoryData,
                    itemSubCategoryDetails,
                    itemInfo,
                    null,
                    poItem?.itemQuantity,
                    poItem?.itemCost,
                    taxData,
                    poItem?.tax,
                    poItem?.discountPer,
                    poItem?.discount,
                    poItem?.transportation,
                    poItem?.subAmount,
                    poItem?.bomItemId,
                    poItem?.purchaseOrderId,
                    poItem?.purchaseOrderItemId,
                    (saleOrderDetails) ? saleOrderDetails.saleOrderId : 0,
                    (saleOrderDetails) ? saleOrderDetails.saleOrderNumber : '',
                    (saleOrderDetails) ? saleOrderDetails.poNumber : '',
                    poItem?.fromPo,
                    poItem?.isActive,
                    null,
                    poItem?.receivedQuantity
                )
                poItems.push(poItemObject);
            }
            const poData = new AllPoDetailsInfo(null, vendor, podata.poNumber, podata.purchaseOrderDate, podata.totalTransportation, podata.expectedDeliveryDate, podata.deliveryAddress, podata.paymentTerms, podata.remarks, podata.note, podata.createdUser, podata.updatedUser, poItems, podata.purchaseOrderId, podata.status, podata.poType, '', '', '', paymentTermsName, podata.deliveryTerms, podata.shippingTerms, plantDetails.data, deliveryPlantDetails.data, billingPlantDetails.data, vendorDetails.data);
            const resultPo = new PoDetailsForPoIdResponse(true, 1111, 'Po Details Retrieved SuccessFully', poData)
            // const newLogDto = new LogsDto(1,'view Po data details by Po Id', 'PoCreation', 0, true, '','')
            // let res = await this.logService.createLog(newLogDto);
            // console.log(res);
            return resultPo
        } else {
            throw new ErrorResponse(9999, 'Failed To Get Po Info')
        }
    }

    async getPoNumberById(purchaseOrderId: number): Promise<any> {
        const purchaseOrder = this.poRepo
            .createQueryBuilder('PoCreation')
            .select([
                'PoCreation.purchase_order_id as purchaseOrderId,PoCreation.sale_order_id as saleOrderId,PoCreation.po_type as poType,PoCreation.po_number as poNumber,PoCreation.status as poStatus'
            ])
            .where('PoCreation.purchase_order_id = :purchaseOrderId', { purchaseOrderId })
            .getRawOne();
        console.log(purchaseOrder);
        if (purchaseOrder) {
            return purchaseOrder;
        } else {
            throw new ErrorResponse(9999, 'No Data Found');
        }
    }

    async getPoDetailReport(req?: PoReportRequest): Promise<CommonResponse> {
        try {
            const manager = getManager()
            let query = `SELECT po.unit_id,DATE(purchase_order_date) as purchaseOrderDate,v.vendor_name as vendor,pt.payment_terms_name as PaymentTerms,DATE(expected_delivery_date) as EDD,po.po_number as poNumber,po.status as status,pi.purchase_order_id,
             po_type as poType,dt.delivery_terms_name as delTerms,st.shipping_term_name as shipmentTerms,
             uc.unit_name AS unit,buc.unit_name AS billingUnit,duc.unit_name AS deliveryUnit,item_category,i.item_name as itemName,pi.item_quantity as itemQuantity,pi.received_quantity as GRNQuantity,item_cost as itemCost,tax as taxAmount,sub_amount as amount,pi.sale_order_id,po.vendor_name,
             isc.item_sub_category as itemSubCategory,ROUND(t.tax_percentage) as taxPer,sinv.po_number as custPoNumber, po.created_at as createdDate , (((pi.received_quantity / pi.item_quantity)*100)) AS excessPercentage,po.life_cycle_Status as lifeCycleStatus FROM `  + poItemsTable + ` pi
                 LEFT JOIN `+ poTable + ` po ON po.purchase_order_id = pi.purchase_order_id
                 LEFT JOIN `+ soTable + ` so ON pi.sale_order_id=so.sale_order_id 
                 LEFT JOIN `+ soInvTable + ` sinv ON pi.sale_order_id = sinv.sale_order_id 
                 LEFT JOIN `+ payTermsTable + ` pt ON pt.payment_terms_id = po.payment_terms
                 LEFT JOIN `+ shipTermsTable + ` st ON st.shipping_term_id = po.shipment_terms
                 LEFT JOIN `+ delTermsTable + ` dt ON dt.delivery_terms_id = po.delivery_terms
                 LEFT JOIN `+ unitCodesTable + ` uc ON uc.unit_code_id = po.unit_id
                 LEFT JOIN `+ itemsTable + ` i ON i.item_id = pi.item_name
                 LEFT JOIN `+ ietmSubCategoryTable + ` isc ON isc.item_sub_category_id = pi.item_sub_category_id
                 LEFT JOIN `+ taxesTable + ` t ON t.tax_id = pi.tax_per
                 LEFT JOIN `+ unitCodesTable + ` buc ON buc.unit_code_id = po.billing_address
                 LEFT JOIN `+ unitCodesTable + ` duc ON duc.unit_code_id = po.delivery_address
                 LEFT JOIN `+ vendorsTable + ` v ON v.vendor_id = po.vendor_name
                 WHERE pi.purchase_order_items_id > 0 and pi.status = 1`;
            if (req.unitId && req.unitId != 5) {
                query = query + ' and po.unit_id = ' + req.unitId;
            }
            if (req.saleOrderId > 0) {
                query = query + ' and pi.sale_order_id = ' + req.saleOrderId;
            }
            if (req.purchaseOrderId > 0) {
                query = query + ' and po.purchase_order_id  = ' + req.purchaseOrderId;
            }
            if (req.vendorId > 0) {
                query = query + ' and po.vendor_name = ' + req.vendorId;
            }
            if (req.fromDate != undefined) {
                query = query + ' and DATE(po.purchase_order_date) >=  "' + req.fromDate + '" and DATE(po.purchase_order_date) <="' + req.toDate + '"';
            }
            if (req.createdDate != undefined) {
                query = query + ' and DATE(po.created_at) >=  "' + req.fromDate + '" and DATE(po.created_at) <="' + req.toDate + '"';
            }
            if (req.itemNameId > 0) {
                query = query + ' and i.item_id = ' + req.itemNameId;
            }
            if (req.itemSubCategoryId > 0) {
                query = query + ' and isc.item_sub_category_id = ' + req.itemSubCategoryId;
            }
            if (req.lifeCycleStatus ) {
                query = query + ' and po.life_cycle_Status = "' + req.lifeCycleStatus + '"';
            }
            if (req.excessPercent) {
                query = query + ' and (((pi.received_quantity / pi.item_quantity)*100)) > ' + req.excessPercent
            }
            query = query + ` order by po.expected_delivery_date,po.po_number`;

            const poDetailData = await manager.query(query);
            if (poDetailData && poDetailData.length > 0) {
                return new CommonResponse(true, 9999, 'data retrived', poDetailData)
            } else {
                return new CommonResponse(false, 1111, 'No data found', undefined)
            }
        } catch (err) {
            throw err
        }
    }
    async getPoLifeCycleStatus(req: UnitRequest): Promise<CommonResponse> {
        const manager = getManager()
        let query = `SELECT po.life_cycle_Status as lifeCycleStatus, po.unit_id FROM `+poItemsTable+` pi
        LEFT JOIN `+poTable+` po ON po.purchase_order_id = pi.purchase_order_id
        LEFT JOIN `+unitCodesTable+ ` uc ON uc.unit_code_id = po.unit_id
        WHERE pi.purchase_order_items_id > 0 `;
        console.log(query)

        if (req.unitId && req.unitId != 5) {
            query = query + ' and po.unit_id = ' + req.unitId;
        }
        query = query + ` GROUP BY po.life_cycle_Status ORDER BY lifeCycleStatus `;
        const data = await manager.query(query);
        if (data) {
            return new CommonResponse(true, 1121, 'Data retrieved successfully', data)
        } else {
            return new CommonResponse(false, 1121, 'No data')
        }
    }
    async getItemSubDropForPoReport(req: UnitRequest): Promise<CommonResponse> {
        const manager = getManager()
        let query = `SELECT isc.item_sub_category_id AS itemSubCategoryId,isc.item_sub_category as itemSubCategory,po.unit_id FROM `  + poItemsTable + ` pi
        LEFT JOIN `+ ietmSubCategoryTable + ` isc ON isc.item_sub_category_id = pi.item_sub_category_id
        LEFT JOIN `+ poTable + ` po ON po.purchase_order_id = pi.purchase_order_id
        LEFT JOIN `+ unitCodesTable + ` uc ON uc.unit_code_id = po.unit_id 
        WHERE pi.purchase_order_items_id > 0 AND isc.item_sub_category_id > 0 `;
        if (req.unitId && req.unitId != 5) {
            query = query + ' and po.unit_id = ' + req.unitId;
        }
        query = query + ` GROUP BY isc.item_sub_category_id ORDER BY itemSubCategory `;
        const data = await manager.query(query);
        if (data) {
            return new CommonResponse(true, 1121, 'Data retrieved successfully', data)
        } else {
            return new CommonResponse(false, 1121, 'No data')
        }
    }
    async getPoDropForPoReport(req: UnitRequest): Promise<CommonResponse> {
        const manager = getManager()
        let query = `SELECT poi.purchase_order_id AS purchaseOrderId,po.po_number AS poNumber,po.unit_id FROM ` + poItemsTable + ` poi 
        LEFT JOIN `+ poTable + ` po ON po.purchase_order_id = poi.purchase_order_id 
        LEFT JOIN `+ unitCodesTable + ` uc ON uc.unit_code_id = po.unit_id 
        WHERE poi.purchase_order_items_id > 0  AND poi.purchase_order_id > 0 `;
        if (req.unitId && req.unitId != 5) {
            query = query + ' and po.unit_id = ' + req.unitId;
        }
        query = query + ` GROUP BY po.po_number ORDER BY poNumber `;
        const data = await manager.query(query);
        if (data) {
            return new CommonResponse(true, 1121, 'Data retrieved successfully', data)
        } else {
            return new CommonResponse(false, 1121, 'No data')
        }
    }
    async getSoDropForPoReport(req: UnitRequest): Promise<CommonResponse> {
        const manager = getManager()
        let query = `SELECT poi.sale_order_id AS saleOrderId,si.po_number AS poNumber,po.unit_id FROM ` + poItemsTable + ` poi 
    LEFT JOIN `+ poTable + ` po ON po.purchase_order_id = poi.purchase_order_id 
    LEFT JOIN `+ soInvTable + ` si ON si.sale_order_id = poi.sale_order_id 
    LEFT JOIN `+ unitCodesTable + ` uc ON uc.unit_code_id = po.unit_id 
    WHERE poi.purchase_order_items_id > 0  AND poi.sale_order_id > 0  `;
        if (req.unitId && req.unitId != 5) {
            query = query + ' and po.unit_id = ' + req.unitId;
        }
        query = query + ` GROUP BY poi.sale_order_id ORDER BY poNumber`;
        const data = await manager.query(query);
        if (data) {
            return new CommonResponse(true, 1121, 'Data retrieved successfully', data)
        } else {
            return new CommonResponse(false, 1121, 'No data')
        }
    }

    async getVendorDropForPoReport(req: UnitRequest): Promise<CommonResponse> {
        console.log(req);
        const manager = getManager()
        let query = `select po.vendor_name as vendorId,v.vendor_name as vendor,po.unit_id from ` + poTable + ` po
         LEFT JOIN `+ vendorsTable + ` v ON v.vendor_id = po.vendor_name
         LEFT JOIN `+ unitCodesTable + ` uc ON uc.unit_code_id = po.unit_id
         WHERE po.vendor_name > 0  `;
        if (req.unitId && req.unitId != 5) {
            query = query + ' and po.unit_id = ' + req.unitId;
        }
        query = query + ` group by po.vendor_name ORDER BY vendor ASC `;
        const data = await manager.query(query);
        if (data) {
            return new CommonResponse(true, 1421, 'Data retrieved successfully', data)
        } else {
            return new CommonResponse(false, 1121, 'No data')
        }
    }

    async getItemDropForPoReport(req: UnitRequest): Promise<CommonResponse> {
        const manager = getManager()
        let query = `select poi.item_name as itemId,i.item_name as itemName, po.unit_id from ` + poItemsTable + ` poi 
         LEFT JOIN `+ itemsTable + ` i ON i.item_id = poi.item_name
         LEFT JOIN `+ poTable + ` po ON po.purchase_order_id = poi.purchase_order_id
         LEFT JOIN `+ unitCodesTable + ` uc ON uc.unit_code_id = po.unit_id
         
          WHERE poi.item_name > 0  ` ;

        if (req.unitId && req.unitId != 5) {
            query = query + ' and po.unit_id = ' + req.unitId;
        }

        query = query + ' group by poi.item_name ORDER BY itemName'
        const data = await manager.query(query);
        if (data) {
            return new CommonResponse(true, 1421, 'Data retrieved successfully', data)
        } else {
            return new CommonResponse(false, 1121, 'No data')
        }
    }

    

    async getPurchaseOrdersForReport(req?: PoReportRequest): Promise<PoReportResponseModel> {
        const manager = getManager()
        let query = `SELECT count(*), p.purchase_order_id as purchaseOrderId,so.sale_order_id as saleOrderNo, soi.po_number, p.po_type as poType, p.purchase_order_date as purchaseOrderDate, p.expected_delivery_date as expectedDeliveryDate, p.po_number as poNumber, v.vendor_name as vendorName, p.status as status, group_concat(soi.po_number," ") as poNumbers FROM ` + poTable + ` p
            
            LEFT JOIN `+ poItemsTable + ` pi ON p.purchase_order_id=pi.purchase_order_id 
            LEFT JOIN `+ soTable + ` so ON pi.sale_order_id=so.sale_order_id 
            LEFT JOIN `+ soInvTable + ` soi ON pi.sale_order_id=soi.sale_order_id 
            LEFT JOIN `+ vendorsTable + ` v ON v.vendor_id=p.vendor_name
            WHERE p.purchase_order_id > 0 `;
        if (req.saleOrderId > 0) {
            query = query + ' and pi.sale_order_id = ' + req.saleOrderId;
        }
        if (req.purchaseOrderId > 0) {
            query = query + ' and p.purchase_order_id  = ' + req.purchaseOrderId;
        }
        if (req.vendorId > 0) {
            query = query + ' and p.vendor_name = ' + req.vendorId;
        }
        if (req.fromDate != undefined) {
            query = query + ' and p.purchase_order_date between "' + req.fromDate + '" and "' + req.toDate + '"';
        }
        query = query + ` group by p.purchase_order_id ORDER By p.purchase_order_date `;


        const purchaseData = await manager.query(query);
        if (purchaseData && purchaseData.length > 0) {
            return new PoReportResponseModel(true, 1225, 'Purchase order Details Retrieved Successfully', purchaseData);
        } else {
            throw new ErrorResponse(9999, 'No Data Found');
        }


    }

    // async getPurchaseOrdersForReport(req?: PoReportRequest): Promise<PoReportResponseModel> {
    //     const purchaseOrder = this.poRepo
    //         .createQueryBuilder('PoCreation')
    //         .select([
    //             'PoCreation.purchase_order_date as purchaseOrderDate,PoCreation.purchase_order_id as purchaseOrderId,PoCreation.sale_order_id as saleOrderId,PoCreation.po_type as poType,PoCreation.po_number as poNumber,PoCreation.status as status, PoCreation.vendor_name as vendorName, PoCreation.expected_delivery_date as expectedDeliveryDate, PoCreation.total_amount as totalAmount' 
    //         ])
    //     if (req) {
    //         if (req.fromDate && req.toDate) {
    //             purchaseOrder.where('Date(purchase_order_date) between DATE_FORMAT("'+req.fromDate+'", "%Y-%m-%d")  and DATE_FORMAT("'+req.toDate+'", "%Y-%m-%d")');
    //             // " DATE_FORMAT(' + req.fromDate + ', "%Y-%m-%d") and" DATE_FORMAT(' + req.toDate+', "%Y-%m-%d")')
    //         }
    //         if (req.soNumber) {
    //             purchaseOrder.andWhere('sale_order_id =' + req.soNumber)
    //         }
    //         if (req.poNumber) {
    //             purchaseOrder.andWhere('purchase_order_id =' + req.poNumber)
    //         }

    //         if (req.vendorName) {
    //             purchaseOrder.andWhere('vendor_name =' + req.vendorName)
    //         }
    //     }

    //     const poDetails = await purchaseOrder.getRawMany();
    //     if (purchaseOrder) {
    //         const poInfo: PoReportDto[] = [];
    //         for (const po of poDetails) {
    //             let saleOrderDetails: SaleOrderDetailViewInfoDTO;
    //             if (po.saleOrderId) {
    //                 const soReq: saleOrder = {
    //                     saleOrderId: po.saleOrderId
    //                 }
    //                 saleOrderDetails = (await this.soService.getSaleOrderInformationById(soReq)).data;
    //             }
    //             const vendorDetails = await this.vendorService.getVendorDataById({ vendorId: po.vendorName });
    //             const poData: PoReportDto = {
    //                 purchaseOrderId: po.purchaseOrderId,
    //                 poType: po.poType,
    //                 soDate: (saleOrderDetails) ? saleOrderDetails.invDate : null,
    //                 purchaseOrderDate: po.purchaseOrderDate,
    //                 expectedDeliveryDate: po.expectedDeliveryDate,
    //                 poNumber: po.poNumber,
    //                 soNumber: (saleOrderDetails) ? saleOrderDetails.saleOrder : null,
    //                 vendorName: vendorDetails.data.vendorName,
    //                 totalAmount: po.totalAmount,
    //                 status: po.status
    //             }
    //             poInfo.push(poData)
    //         }

    //         return new PoReportResponseModel(true, 1111, 'Po Details Retrieved Successfully', poInfo);
    //     } else {
    //         throw new ErrorResponse(9999, 'No Data Found');
    //     }
    // }
    async getPoNumber(): Promise<PoNumbersResponseModel> {
        const poDTO: PoNumbersModel[] = [];
        const itemCategoryEntities: PoNumbersModel[] = await this.poRepository.find({
            select: ['purchaseOrderId', 'poNumber'],
            order: { 'createdAt': 'DESC' }
        });
        if (itemCategoryEntities && itemCategoryEntities.length > 0) {
            itemCategoryEntities.forEach(itemCatEntity => {
                poDTO.push(new PoNumbersModel(itemCatEntity.purchaseOrderId, itemCatEntity.poNumber));
            });
            const response = new PoNumbersResponseModel(true, 11108, "PO Numbers retrieved successfully", poDTO);
            return response;
        } else {
            throw new ErrorResponse(99998, 'Data not found');
        }
    }


    async getCancelledSosForPo() {
        try {
            const manager = getManager();
            let trackerQuery = `SELECT po_type as poType, s.sale_order_no AS soNumber, inv.po_number AS poNumber, po.po_number as purchaseOrderNo, purchase_order_date as purchaseOrderDate, v.vendor_name as vendorName, expected_delivery_date as expectedDeliveryDate, po.status, po.purchase_order_id as purchaseOrderId  FROM ` + appSettings.procure_db + `.purchase_order po 
                LEFT JOIN ` + appSettings.procure_db + `.purchase_order_items pi ON pi.purchase_order_id=po.purchase_order_id 
                LEFT JOIN ` + appSettings.sales_db + `.sale_order s ON s.sale_order_id=pi.sale_order_id 
                LEFT JOIN ` + appSettings.sales_db + `.so_invoice_details inv ON inv.sale_order_id=s.sale_order_id 
                LEFT JOIN ` + appSettings.masters_db + `.vendors v ON v.vendor_id=po.vendor_name where s.status='${SoStatusEnum.CANCELLED}' and po.status='${StatusEnum.OPEN}'`;

            trackerQuery += ` group by pi.purchase_order_id, pi.sale_order_id having count(DISTINCT pi.sale_order_id)=1`;

            const poData: AllPoDetailsInfo[] = await manager.query(trackerQuery);

            if (poData?.length > 0) {
                return new GetAllPoResponse(true, 1525, 'Po Details Retrieved Successfully', poData);
            } else {
                throw new ErrorResponse(9999, 'No Data Found');
            }
        } catch (error) {
            return error;
        }
    }

    async ClosePoForCancelledSo(poId: number): Promise<CommonResponse> {
        try {
            const poInfo = await this.poRepo.findOne({ where: { purchaseOrderId: poId }, relations: ['poCreationItemsInfo'] });
            if (poInfo) {
                // update po status to cancel
                const updateStatus = await this.poRepo.update({ purchaseOrderId: poId }, { status: StatusEnum.CLOSED });
                if (updateStatus.affected) {
                    if (poInfo.poType == POTypeEnum.WITHSO) {
                        if (poInfo.poCreationItemsInfo && poInfo.poCreationItemsInfo.length) {
                            for (const item of poInfo.poCreationItemsInfo) {
                                const soReq: saleOrder = {
                                    saleOrderId: item.saleOrderId
                                }
                                const updateSo = await this.soService.UpdateSoForPo(soReq);
                            }
                        }
                    }
                } else {
                    throw new ErrorResponse(9999, 'Failed To Cancel Po');
                }
            }
            return new CommonResponse(true, 11111, 'PO Cancelled Successfully');
        } catch (error) {
            return error;
        }
    }


    async CancelPoForCancelledSo(poId: number): Promise<CommonResponse> {
        try {
            const poInfo = await this.poRepo.findOne({ where: { purchaseOrderId: poId }, relations: ['poCreationItemsInfo'] });
            if (poInfo) {
                // update po status to cancel
                const updateStatus = await this.poRepo.update({ purchaseOrderId: poId }, { status: StatusEnum.CANCELLED });
                const updateItemStatus = await this.itemsRepo.update({ purchaseOrderId: poId }, { isActive: false });
                if (updateStatus.affected && updateItemStatus.affected) {
                    if (poInfo.poType == POTypeEnum.WITHSO) {
                        if (poInfo.poCreationItemsInfo && poInfo.poCreationItemsInfo.length) {
                            for (const item of poInfo.poCreationItemsInfo) {
                                const soReq: saleOrder = {
                                    saleOrderId: item.saleOrderId,
                                    poQuantity: item.itemQuantity,
                                    itemId: item.itemName
                                }
                                const updateSo = await this.soService.UpdateSoForPo(soReq);
                                if(updateSo.status){
                                    const bomUpdate = await this.soService.updateBomPo(soReq)
                                }else{
                                    throw new ErrorResponse(9999, 'Failed To Cancel Po');
                                }


                            }
                        }
                    }
                } else {
                    throw new ErrorResponse(9999, 'Failed To Cancel Po');
                }
            }
            return new CommonResponse(true, 11111, 'PO Cancelled Successfully');
        } catch (error) {
            return error;
        }
    }


    async getCancelledPosData(req?: PoFilterData): Promise<GetAllPoResponse> {

        const manager = getManager();
        let trackerQuery = `SELECT po_type as poType, GROUP_CONCAT(s.sale_order_no," ") AS soNumber, GROUP_CONCAT(inv.po_number, " ") AS poNumber, po.po_number as purchaseOrderNo, purchase_order_date as purchaseOrderDate, v.vendor_name as vendorName, expected_delivery_date as expectedDeliveryDate, po.status, po.purchase_order_id as purchaseOrderId  ,po.unit_id as unitId,uc.unit_name FROM ` + appSettings.procure_db + `.purchase_order po 
        LEFT JOIN ` + appSettings.procure_db + `.purchase_order_items pi ON pi.purchase_order_id=po.purchase_order_id 
        LEFT JOIN ` + appSettings.sales_db + `.sale_order s ON s.sale_order_id=pi.sale_order_id 
        LEFT JOIN ` + appSettings.sales_db + `.so_invoice_details inv ON inv.sale_order_id=s.sale_order_id
        LEFT JOIN ` + appSettings.masters_db + `.unitcodes uc ON uc.unit_code_id = po.unit_id 
        LEFT JOIN ` + appSettings.masters_db + `.vendors v ON v.vendor_id=po.vendor_name where po.status= '${StatusEnum.CANCELLED}'`;

        if ((([
            EmployeeRolesEnum.ADMIN,
            EmployeeRolesEnum.HO_PACKAGING_MANAGER
        ].indexOf(req.role)) === -1) && req.fromDate && req.toDate) {
            trackerQuery += ` and delivery_address= ${req.unitId} Date(expected_delivery_date) between '${moment(req.fromDate).format("YYYY-MM-DD")}' and '${moment(req.toDate).format("YYYY-MM-DD")}'`
        }

        if ((([
            EmployeeRolesEnum.ADMIN,
            EmployeeRolesEnum.HO_PACKAGING_MANAGER
        ].indexOf(req.role)) === -1) && !(req.fromDate && req.toDate)) {
            trackerQuery += ` where delivery_address= ${req.unitId}`;
        }

        if (!(([
            EmployeeRolesEnum.ADMIN,
            EmployeeRolesEnum.HO_PACKAGING_MANAGER
        ].indexOf(req.role)) === -1) && (req.fromDate && req.toDate)) {
            trackerQuery += ` where Date(expected_delivery_date) between '${moment(req.fromDate).format("YYYY-MM-DD")}' and '${moment(req.toDate).format("YYYY-MM-DD")}'`;
        }

        trackerQuery += ` group by po.purchase_order_id`;

        const poData: AllPoDetailsInfo[] = await manager.query(trackerQuery);

        if (poData && poData.length > 0) {
            return new GetAllPoResponse(true, 1525, 'Po Details Retrieved Successfully', poData);
        } else {
            throw new ErrorResponse(9999, 'No Data Found');
        }
    }

    async getRevisedSos(req?: PoFilterData): Promise<GetAllPoResponse> {

        const manager = getManager();
        let trackerQuery = `SELECT po_type as poType, GROUP_CONCAT(s.sale_order_no," ") AS soNumber, GROUP_CONCAT(inv.po_number, " ") AS poNumber, po.po_number as purchaseOrderNo, purchase_order_date as purchaseOrderDate, v.vendor_name as vendorName, expected_delivery_date as expectedDeliveryDate, po.status, po.purchase_order_id as purchaseOrderId ,po.unit_id as unitId,uc.unit_name FROM ` + appSettings.procure_db + `.purchase_order po 
        LEFT JOIN ` + appSettings.procure_db + `.purchase_order_items pi ON pi.purchase_order_id=po.purchase_order_id 
        LEFT JOIN ` + appSettings.sales_db + `.sale_order s ON s.sale_order_id=pi.sale_order_id 
        LEFT JOIN ` + appSettings.sales_db + `.so_invoice_details inv ON inv.sale_order_id=s.sale_order_id 
        LEFT JOIN ` + appSettings.sales_db + `.bom_details bom ON bom.sale_order_id=s.sale_order_id and pi.item_name = bom.item_id 
        LEFT JOIN ` + appSettings.masters_db + `.unitcodes uc ON uc.unit_code_id = po.unit_id
        LEFT JOIN ` + appSettings.masters_db + `.vendors v ON v.vendor_id=po.vendor_name where bom.is_required='${GlobalStatus.NO}' and po.status='${StatusEnum.OPEN}'`;

        if ((([
            EmployeeRolesEnum.ADMIN,
            EmployeeRolesEnum.HO_PACKAGING_MANAGER
        ].indexOf(req.role)) === -1) && req.fromDate && req.toDate) {
            trackerQuery += ` and delivery_address= ${req.unitId} Date(expected_delivery_date) between '${moment(req.fromDate).format("YYYY-MM-DD")}' and '${moment(req.toDate).format("YYYY-MM-DD")}'`
        }

        if ((([
            EmployeeRolesEnum.ADMIN,
            EmployeeRolesEnum.HO_PACKAGING_MANAGER
        ].indexOf(req.role)) === -1) && !(req.fromDate && req.toDate)) {
            trackerQuery += ` where delivery_address= ${req.unitId}`;
        }

        if (!(([
            EmployeeRolesEnum.ADMIN,
            EmployeeRolesEnum.HO_PACKAGING_MANAGER
        ].indexOf(req.role)) === -1) && (req.fromDate && req.toDate)) {
            trackerQuery += ` where Date(expected_delivery_date) between '${moment(req.fromDate).format("YYYY-MM-DD")}' and '${moment(req.toDate).format("YYYY-MM-DD")}'`;
        }

        trackerQuery += ` group by po.purchase_order_id`;

        const poData: AllPoDetailsInfo[] = await manager.query(trackerQuery);

        if (poData && poData.length > 0) {
            return new GetAllPoResponse(true, 1525, 'Po Details Retrieved Successfully', poData);
        } else {
            throw new ErrorResponse(9999, 'No Data Found');
        }
    }


    async getTransferredSos(): Promise<GetAllPoResponse> {

        const manager = getManager();
        let trackerQuery;
        var poData = [];
        const transferredSoIds = await this.soService.getTransferredSaleOrders();
        console.log(transferredSoIds.data, 'transferredSoIds')
        if (transferredSoIds.status) {
            //below line using to convert array of objets to array of properties
            const arrayOfSoIds = transferredSoIds.data.map(({ saleOrderId }) => saleOrderId)
            trackerQuery = `SELECT po_type as poType, GROUP_CONCAT(s.sale_order_no," ") AS soNumber, GROUP_CONCAT(inv.po_number, " ") AS poNumber, po.po_number as purchaseOrderNo, purchase_order_date as purchaseOrderDate, v.vendor_name as vendorName, expected_delivery_date as expectedDeliveryDate, po.status, po.purchase_order_id as purchaseOrderId,po.unit_id as unitId,uc.unit_name  FROM ` + appSettings.procure_db + `.purchase_order po 
            LEFT JOIN ` + appSettings.procure_db + `.purchase_order_items pi ON pi.purchase_order_id=po.purchase_order_id 
            LEFT JOIN ` + appSettings.sales_db + `.sale_order s ON s.sale_order_id=pi.sale_order_id 
            LEFT JOIN ` + appSettings.sales_db + `.so_invoice_details inv ON inv.sale_order_id=s.sale_order_id 
            LEFT JOIN ` + appSettings.masters_db + `.unitcodes uc ON uc.unit_code_id = po.unit_id
            LEFT JOIN ` + appSettings.sales_db + `.bom_details bom ON bom.sale_order_id=s.sale_order_id and pi.item_name = bom.item_id 
            LEFT JOIN ` + appSettings.masters_db + `.vendors v ON v.vendor_id=po.vendor_name where  pi.sale_order_id IN (` + arrayOfSoIds.toString() + `)`;
            trackerQuery += ` group by po.purchase_order_id`;

            poData = await manager.query(trackerQuery);
            if (poData && poData.length > 0) {
                return new GetAllPoResponse(true, 1525, 'Po Details Retrieved Successfully', poData);
            } else {
                throw new ErrorResponse(9999, 'No Data Found');
            }
        } else {
            throw new ErrorResponse(9999, 'No Transferred SaleOrders  Found');
        }



    }
    // @Cron('0 19 * * *')
    async getPoUsage() {
        try {
            const manager = getManager();
            let query = `SELECT puc.unit_name,COUNT(*) AS cnt FROM erpx_dev_procurement.purchase_order po
        LEFT JOIN erpx_dev_masters.unitcodes puc ON puc.unit_code_id = po.unit_id WHERE DATE(po.created_at)=DATE(NOW())
        GROUP BY po.unit_id ORDER BY po.unit_id `
            const poData = await manager.query(query);
            console.log('poData')
            console.log(poData)
            const messageType = new Date();
            const month = messageType.getMonth() + 1
            const PoDate = messageType.getFullYear() + '-' + month + '-' + messageType.getDate();
            const time = messageType.toLocaleTimeString();
            let messageStatus

            if (poData.length > 0) {
                let purchaseData = PoDate+" : "+time+"*\n";
                for (const sd of poData) {
                    purchaseData += sd.unit_name + "   *" + sd.cnt + "*\n";
                }
                messageStatus = await this.wtsAppBroadCatService.sendWhatsappMessage(new BroadCastMessageRequest(2,purchaseData,[whatsApp.UsageReport]));
                // const message = await new MessageRequest(whatsApp.UsageReport, `PO :${PoDate} : ${time}`, purchaseData, "Schemax")
                // console.log(message);
                // var messageStatus = await this.wpService.sendPersonalMessage(message);
            } else {
                const NopurchaseData = PoDate+" : "+time+"*\n"+'No Data';
                messageStatus = await this.wtsAppBroadCatService.sendWhatsappMessage(new BroadCastMessageRequest(2,NopurchaseData,[whatsApp.UsageReport]));
                // const message = await new MessageRequest(whatsApp.UsageReport, `PO :${PoDate} : ${time}`, "No data", "Schemax")
                // console.log(message);
                // var messageStatus = await this.wpService.sendPersonalMessage(message);
            }
            console.log(messageStatus);
            return new CommonResponse(true, 11108, "Message sent successfully", poData)
        } catch (error) {
            return new CommonResponse(false, 11108, error)
        }
    }

    //cron job to uodate purchase order life cycle status
    async PoLifeCycleStatus(): Promise<CommonResponse> {
        const manager = new GenericTransactionManager()
        try {
            const poData = await this.poRepo.find({ where: { status: Not(StatusEnum.CANCELLED) } })
            console.log(poData)
            let postatus = POLifeCycleStatusEnum.OPEN
            let updateFlag = new Set<boolean>()
            await manager.startTransaction();
            for (const [index, poDataItem] of poData.entries()) {
                if (moment(poDataItem.purchaseOrderDate).format('yyyy-mm-dd') == moment(new Date()).format('yyyy-mm-dd')) {
                    postatus = POLifeCycleStatusEnum.OPEN
                }
                if (moment(poDataItem.purchaseOrderDate).format('yyyy-mm-dd') < moment(new Date()).format('yyyy-mm-dd')) {
                    postatus = POLifeCycleStatusEnum.WORK_IN_PROGRESS1
                }
                //risk when Lead time greater than 5 days
                let poETD = poDataItem.expectedDeliveryDate ? new Date("'" + poDataItem.expectedDeliveryDate + "'") : null;
                if (poETD) {
                    const currentDate = new Date();
                    var diffTime = Math.abs(poETD.getTime() - currentDate.getTime());
                    const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
                    if (diffDays == 5 && poDataItem.status != StatusEnum.CLOSED) {
                        postatus = POLifeCycleStatusEnum.WORK_IN_PROGRESS2
                    }
                }
                const grnData = await this.grnService.getGrnByPoId(new GrnQtyRequest(poDataItem.purchaseOrderId, null, null, null))
                if (grnData.status) {
                    postatus = POLifeCycleStatusEnum.SHIPPED
                    if (moment(grnData.data.grnDate).format('YYYY-MM-DD') < moment(poDataItem.expectedDeliveryDate).format('YYYY-MM-DD')) {
                        postatus = POLifeCycleStatusEnum.EARLY_SHIPPED
                    }
                    if (moment(grnData.data.grnDate).format('YYYY-MM-DD') > moment(poDataItem.expectedDeliveryDate).format('YYYY-MM-DD')) {
                        postatus = POLifeCycleStatusEnum.DELAY_SHIPPED
                    }

                } else {
                    if (moment(Date.now()).format('YYYY-MM-DD') > moment(poDataItem.expectedDeliveryDate).format('YYYY-MM-DD')) {
                        postatus = POLifeCycleStatusEnum.DELAYED
                    }
                }
                // }
                const updateStatus = await manager.getCustomRepository(PoRepository).update({ purchaseOrderId: poDataItem.purchaseOrderId }, { poLifeCyclestatus: postatus })
                if (updateStatus.affected) {
                    updateFlag.add(true)
                } else {
                    updateFlag.add(false)
                    break;
                }
            }
            if (!updateFlag.has(false)) {
                await manager.completeTransaction()
                return new CommonResponse(true, 5555, 'updated')

            } else {
                await manager.releaseTransaction()
            }
        } catch (err) {
            await manager.releaseTransaction()
            return new CommonResponse(false, 5555, err)
        }
        return
    }

    @Cron('0 8 * * *')
    async getPoLifeCycleStatusCount() {
        try {
            const manager = getManager();
            let poData;
            // let urlMsg = '*click the below link for detail view*';
            let poLifeCycleUrl = appSettings.whatsapp_redirection_url + '/purchase-order-report';
            let poLifeCycleStatusCount = `SELECT life_cycle_status AS lifeCycleStatus, SUM(kakinada) AS kakinada, SUM(Unit1) AS unit1, SUM(Unit2) AS unit2 ,plant_address FROM (
            SELECT life_cycle_status,plant_address,
            IF(po.plant_address=1,COUNT(1),0) AS kakinada,
            IF(po.plant_address=2,COUNT(1),0) AS Unit1,
            IF(po.plant_address=3,COUNT(1),0) AS Unit2
            FROM erpx_dev_procurement.purchase_order po 
            GROUP BY life_cycle_status,plant_address
            ) AS sd GROUP BY life_cycle_status`
            poData = await manager.query(poLifeCycleStatusCount);
            const time = moment().subtract(1, "days").format('MMMM Do, YYYY');
            const newTime = moment().subtract(0, "days").format('MMMM Do, YYYY')
            const mes = (poData.map(i => {
                console.log(i.lifeCycleStatus);
                return (" \\n*" + i.lifeCycleStatus + " :*\\n " + 'unit1 :' + i.unit1 + " \\n " + 'unit2 :' + i.unit2 + " \\n "+ 'unit3 :' + i.kakinada + " \\n ")
            })+ "\\n")

            //whatsapp broadcast API calling to facebook

            const parameters = [
                { "type": "text", "text": time},
                { "type": "text", "text": newTime},
                { "type": "text", "text": mes},
                // { "type": "text", "text": poLifeCycleUrl},
              ];
              console.log('parameters',parameters)
              const contacts = whatsApp.contacts;
              let statusFlag
              for(const contact of contacts){
                  const req = await new MessageParameters(contact, 'po_life_cycle_status_report', parameters,'en_us')

                  const messageStatus = await this.wpService.sendMessageThroughFbApi(req);
              console.log('messageStatus',messageStatus)

                  if(!messageStatus.status){
                      statusFlag = false
                      break
                  }else{
                    statusFlag = true
                    const whatsapplogDto = new WhatsAppLogDto(contact,'po_life_cycle_status_report','Sandhya',GlobalVariableValues.companyId,GlobalVariableValues.procurementmoduleId)
                    await this.wtsAppBroadCatService.createWhatappLog(whatsapplogDto)
                  }
              }
            //whatsapp broadcast API calling
            // const messageStatus = await this.wtsAppBroadCatService.sendWhatsappMessage(new BroadCastMessageRequest(3,'Status Till '+time+'\n'+'Whatsapp Generated On : '+newTime+mes,[whatsApp.UsageReport]));
            // const message = await new MessageRequest(whatsApp.UsageReport, "Po Life Cycle Status for" + time, mes, "ERPX")
            // var messageStatus = await this.wpService.sendPersonalMessage(message);
            if (statusFlag) {
                return new CommonResponse(true, 11108, "Message Sent Sucessfully", statusFlag)
            }

        } catch (error) {
            return new CommonResponse(false, 11508, "Error while sending message")
        }

    }

    async getPoLifeStatus(req: UnitRequest): Promise<CommonResponse> {
        try {
            const manager = getManager();
            let query
            let dataArray = []

            query = `SELECT life_cycle_status AS lifeCycleStatus, SUM(kakinada) AS kakinada, SUM(Unit1) AS unit1, SUM(Unit2) AS unit2 ,plant_address FROM (
                SELECT life_cycle_status,plant_address,
                IF(po.plant_address=1,COUNT(1),0) AS kakinada,
                IF(po.plant_address=2,COUNT(1),0) AS Unit1,
                IF(po.plant_address=3,COUNT(1),0) AS Unit2
                FROM `+ appSettings.procure_db + `.purchase_order po 
                GROUP BY life_cycle_status,plant_address
                ) AS sd `;
            if (req.unitId && req.unitId != 5) {
                query += ` where plant_address=` + req.unitId;
            }
            query += ` GROUP BY life_cycle_status`;
            const statusCounts = await manager.query(query)
            console.log('******', statusCounts)
            if (!statusCounts[0].life_cycle_status) {
                statusCounts[0].kakinada = 0
                statusCounts[0].unit1 = 0
                statusCounts[0].unit2 = 0
            }
            dataArray.push(statusCounts[0])
            return new CommonResponse(true, 5555, 'data retrived', statusCounts)
        }
        catch (error) {
            return new CommonResponse(false, 11508, "Error while getting PoLife status")
        }
    }
    async getPoDeadStock(req: UnitRequest): Promise<CommonResponse> {
        try {
            const manager = getManager();
            let deadQuery = `SELECT s.item_id AS itemId ,i.item_name AS itemName ,s.created_at AS createdAt,DATEDIFF(DATE(NOW()),s.created_at) AS days,s.unit_id AS unitId, ROUND(s.physical_quantity)AS qty  FROM ` + appSettings.procure_db + `.stock s
            LEFT JOIN ` + appSettings.masters_db + `.items i ON i.item_id = s.item_id 
            HAVING days>90  ORDER BY s.created_at LIMIT 0, 5`;
            if (req.unitId && req.unitId != 5) {
                deadQuery += ` where s.unit_id=` + req.unitId;
            }
            // deadQuery +=  ` ORDER BY s.created_at LIMIT 0, 5`;
            const dead = await manager.query(deadQuery)
            return new CommonResponse(true, 4444, 'Data Retraived Successfully', dead)
        }
        catch (error) {
            return new CommonResponse(false, 55221, "Error while getting Po Dead Stock")
        }
    }
    async getPoSubCategory(req: UnitRequest): Promise<CommonResponse> {
        try {
            const manager = getManager();
            let ItemSubQuery = `SELECT CONCAT(s.item_sub_category_id) AS subCatId,ic.item_sub_category AS subCat,COUNT(s.item_sub_category_id ) AS qty , s.unit_id AS unitId ,ROUND(SUM(s.physical_quantity)) AS phyQty
            FROM ` + appSettings.procure_db + `.stock s
            LEFT JOIN ` + appSettings.masters_db + `.item_sub_categories ic ON ic.item_sub_category_id = s.item_sub_category_id WHERE s.item_sub_category_id> 0 and ic.item_sub_category IS NOT NULL`;
            if (req.unitId && req.unitId != 5) {
                ItemSubQuery += ` and s.unit_id=` + req.unitId;
            }
            ItemSubQuery += ` GROUP BY s.item_sub_category_id `;
            const ItemSub = await manager.query(ItemSubQuery);
            return new CommonResponse(true, 7777,'Data Retraived Successfully', ItemSub)
        }
        catch (error) {
            return new CommonResponse(false, 5555, "Error while getting Po SubCategory Stock")
        }
    }
    async getSoWiseQty(req: UnitRequest): Promise<CommonResponse> {
        try {
            const manager = getManager();
            let SoWiseQuery = `SELECT  ROUND(SUM(s.physical_quantity)) AS soQty , s.unit_id AS unit FROM ` + appSettings.procure_db + `.stock s
            LEFT JOIN ` + appSettings.masters_db + `.items i ON i.item_id = s.item_id WHERE i.brand !=75 `;
            if (req.unitId && req.unitId != 5) {
                SoWiseQuery += ` and s.unit_id=` + req.unitId;
            }
            const soQty = await manager.query(SoWiseQuery);
            return new CommonResponse(true, 7777,'Data Retraived Successfully', soQty)
        }
        catch (error) {
            return new CommonResponse(false, 5555, "Error while getting So Wise Qty Stock")
        }
    }
    async getDummyWiseQty(req: UnitRequest): Promise<CommonResponse> {
        try {
            const manager = getManager();
            let DummyWiseQuery = `SELECT  ROUND(SUM(s.physical_quantity)) AS dummyQty , s.unit_id AS unit FROM ` + appSettings.procure_db + `.stock s
            LEFT JOIN ` + appSettings.masters_db + `.items i ON i.item_id = s.item_id WHERE i.brand =75 `;
            if (req.unitId && req.unitId != 5) {
                DummyWiseQuery += ` and s.unit_id=` + req.unitId;
            }
            const dummyQty = await manager.query(DummyWiseQuery);
            return new CommonResponse(true, 7777,'Data Retraived Successfully', dummyQty)
        }
        catch (error) {
            return new CommonResponse(false, 5555, "Error while getting Dummy Wise Qty Stock")
        }
    }
    async fastMovingProd(req: UnitRequest): Promise<CommonResponse> {
        try {
            const manager = getManager();
            let TopFiveQuery = `SELECT i.item_name AS itemName ,sc.item_id AS itemId , COUNT(sc.item_id) AS cnt , s.unit_id AS unit FROM ` + appSettings.procure_db + `.store_consumption_items sc
            LEFT JOIN ` + appSettings.masters_db + `.items i ON i.item_id = sc.item_id
            LEFT JOIN ` + appSettings.procure_db + `.store_consumption s ON s.store_consumption_id = sc.store_consumption_id`;
            if (req.unitId && req.unitId != 5) {
                TopFiveQuery += ` Where s.unit_id=` + req.unitId;
            }
            TopFiveQuery += ` GROUP BY sc.item_id  ORDER BY cnt DESC LIMIT 5`;
            const topFive = await manager.query(TopFiveQuery);
            return new CommonResponse(true, 7777,'Data Retrieved Successfully', topFive)
        }
        catch (error) {
            return new CommonResponse(false, 5555, "Error while getting fast moving product")
        }
    }
    @Cron('0 8 * * *')
    async getSkippedPoCount(){
      try{
        const manager = getManager();
        let skipData
        // let urlMsg = '*click the below👇👇 link for detail view*';
        // let skippedUrl = appSettings.whatsapp_redirection_url + '/purchase-order-report';
        let query = `SELECT SUM(IF(po.unit_id =1,1,0)) AS kkd,SUM(IF(po.unit_id =2,1,0)) AS unit1,SUM(IF(po.unit_id=3,1,0)) AS unit2 FROM ${appSettings.procure_db }.purchase_order po 
        WHERE DATE(NOW()) > DATE(po.expected_delivery_date) AND po.status NOT IN ('cancelled','CLOSED')`;
        skipData = await manager.query(query);
            const time = moment().subtract(1, "days").format('MMMM Do, YYYY')
            const newTime = moment().subtract(0, "days").format('MMMM Do, YYYY')
            console.log(skipData)
            //   const mes = skipData.map(i => {
                //   console.log(i.skipped);
                  const mes =  ( " \n " + 'unit1:' + skipData[0].unit1 + " \n " + 'unit2:' + skipData[0].unit2 + "  \n "+ 'unit3:' + skipData[0].kkd + "  \n "  )+ "\n "
            //   })
              console.log('mesuma')
              console.log(mes)
              
                // const messageStatus = await this.wtsAppBroadCatService.sendWhatsappMessage(new BroadCastMessageRequest(1,'Status Till '+time+'\n'+'Whatsapp Generated On : '+newTime+mes,[whatsApp.UsageReport]));
                //Whatsapp integration API calling to Facebook
                const unit1pos = skipData[0].unit1 >= 0 ? "*"+skipData[0].unit1+"*":"No Data"
                const parameters = [
                    { "type": "text", "text": time},
                    { "type": "text", "text": newTime},
                    { "type": "text", "text": skipData[0].unit1 >= 0 ? "*"+skipData[0].unit1+"*" : "No Data" },
                    { "type": "text", "text": skipData[0].unit2 >= 0 ? "*"+skipData[0].unit2+"*" : "No Data" },
                    { "type": "text", "text": skipData[0].kkd >= 0 ? "*"+skipData[0].kkd+"*" : "No Data" },
                  ];
                  const contacts = whatsApp.contacts;
                  let statusFlag = true
                  for(const contact of contacts){
                      const req = await new MessageParameters(contact, 'skipped_po_count', parameters,'en_us')
                      const messageStatus = await this.wpService.sendMessageThroughFbApi(req);
                      console.log(messageStatus,'messageStatus')
                      if(!messageStatus.status){
                          statusFlag = false
                          break
                      }else{
                        statusFlag = true
                        const whatsapplogDto = new WhatsAppLogDto(contact,'skipped_po_count','Sandhya',GlobalVariableValues.companyId,GlobalVariableValues.procurementmoduleId)
                        await this.wtsAppBroadCatService.createWhatappLog(whatsapplogDto)
                      }
                  }

            //   const message = await new MessageRequest(whatsApp.UsageReport, "🏭Plant Wise Skipped Po Count As On " + time, mes, "ERPX")
            //   var messageStatus = await this.wpService.sendPersonalMessage(message);
              if (statusFlag) {
                  return new CommonResponse(true, 11108, "Message Sent Sucessfully", statusFlag)
              }
      }catch (error) {
        console.log(error)
        return new CommonResponse(false, 11108, "Error while sending message")
      }
    }
    async getPoQtyGrnQty(dtoObj: PoQtyGrnDtoReqDto): Promise <CommonResponse>{
        try {  
            const manager = getManager();  
            let queryIn='';  
            let monthNo=0;           
            // const quarterInfo=3;
            if(!dtoObj.month){
                const dateData = new Date();
                monthNo = dateData.getMonth();
            }else{
                monthNo=dtoObj.month;
            }
           
            let yearNo=0;
            if(!dtoObj.year){
                const dateData = new Date();
                yearNo = dateData.getFullYear();
            }else{
                yearNo=dtoObj.year;
            }
            const names = []; 
            const namesData = [];

            let quarterName;
            const qunarterCount = {1 : 'quarter1',  2 : 'quarter1', 3 : 'quarter1', 4 : 'quarter2', 5 : 'quarter2', 6 : 'quarter2', 7 : 'quarter3', 8 : 'quarter3', 9 : 'quarter3', 10 : 'quarter4', 11 : 'quarter4', 12 : 'quarter4'};
            const monthData ={1: 'Jan', 2: 'Feb', 3: 'Mar', 4: 'Apr', 5: 'May', 6: 'Jun', 7: 'Jul', 8: 'Aug', 9: 'Sep', 10: 'Oct', 11: 'Nov', 12: 'Dec'};
            let mapKey;
            let querySelect;
            let queryWhere;
            let queryGroup;
            const monthInfo=monthNo-1;
            let allNames;
            
           
            /** For Storing Names of the Series Data*/
            if(dtoObj.reportType == ReportTypeENum.DAYWISE){
                /** Assigning all dateData */               
                const date = new Date(yearNo, monthInfo, 1);   
                while (date.getMonth() === monthInfo) {
                    names.push(moment(new Date(date)).format('YYYY-MM-DD'));                    
                    date.setDate(date.getDate() + 1);
                }

                /**Day QueryFilter */
                querySelect = 'DATE(poi.created_at) AS reportedDate';
                queryGroup = 'DATE(poi.created_at)';
                queryWhere = 'MONTH(poi.created_at)='+monthNo+'';
                allNames = names;
            }else if(dtoObj.reportType == ReportTypeENum.WEEKWISE){
                let month;      
                if (monthNo < 10)
                month = "0" + monthNo;            
                const date = "01." + month + "." + yearNo;
                const first = moment(date, 'dd.MM.yyyy').startOf('month').week();
                const last = moment(date, 'dd.MM.yyyy').endOf('month').week();
                for (let i = first; i < last; i++) {
                    namesData.push(i);
                    names.push(i + " " + monthData[monthNo]);
                }
                 /** Month QueryFilter */
                 querySelect = 'WEEK(poi.created_at) AS reportedDate';
                 queryGroup = 'WEEK(poi.created_at)';
                 queryWhere = 'MONTH(poi.created_at)='+monthNo+'';
                 allNames = namesData;
             }else{
                 const quarterNames = ['Jan - Mar', 'Apr - Jun', 'Jul - Sep', 'Oct - Dec'];
                 const quarterData = ['quarter1', 'quarter2', 'quarter3', 'quarter4'];
                 for (const quanrter of quarterNames) {
                     names.push(quanrter + " " + yearNo);                
                 }
                 /** Year QueryFilter */
                 querySelect = 'MONTH(poi.created_at) AS reportedDate';
                 queryGroup = 'MONTH(poi.created_at)';
                 queryWhere = 'YEAR(poi.created_at)='+yearNo+'';
                 allNames = quarterData;
             }             
           
            queryIn = `SELECT poi.item_quantity AS poQty , poi.received_quantity AS grnQty , po.unit_id AS unitId , `+querySelect+` FROM erpx_dev_procurement.purchase_order_items poi LEFT JOIN erpx_dev_procurement.purchase_order po ON po.purchase_order_id = poi.purchase_order_id WHERE poi.received_quantity>0 AND `+queryWhere+``;
            if (dtoObj.unitId && dtoObj.unitId != 5) {
                queryIn +=` and po.unit_id=` + dtoObj.unitId +``;
            };
            queryIn += ` group by `+ queryGroup +``;
            const reportDataIn = await manager.query(queryIn);
            
            // console.log(reportDataIn);
            if(reportDataIn.length<1){
                throw new CommonResponse(false,99998, 'No Records Found');
            }   
              
             /** Fetching  Stock In Informaiton */
            const poGrnDataMap = new Map<string, PoGrnForQty>();
            for(const poGrnData of reportDataIn){
                if(dtoObj.reportType == ReportTypeENum.DAYWISE){
                    const mapKey = moment(poGrnData.reportedDate).format('YYYY-MM-DD');
                    if(!poGrnDataMap.has(mapKey)){
                        const poGrnObj = new PoGrnForQty();
                
                        poGrnObj.poQty = poGrnData.poQty;                
                        poGrnObj.grnQty = poGrnData.grnQty; 
                        poGrnDataMap.set(mapKey, poGrnObj);   
                    }else{
                        poGrnDataMap.get(mapKey).poQty += poGrnData.poQty;     
                        poGrnDataMap.get(mapKey).grnQty += poGrnData.grnQty;    
                    }
                }else if(dtoObj.reportType == ReportTypeENum.WEEKWISE){ 
                    const mapKey = poGrnData.reportedDate;
                    if(!poGrnDataMap.has(mapKey)){
                        const poGrnObj = new PoGrnForQty();
                
                        poGrnObj.poQty = poGrnData.poQty;                
                        poGrnObj.grnQty = poGrnData.grnQty; 
                        poGrnDataMap.set(mapKey, poGrnObj);   
                    }else{
                        poGrnDataMap.get(mapKey).poQty += poGrnData.poQty;     
                        poGrnDataMap.get(mapKey).grnQty += poGrnData.grnQty;     
                    }
                }else{                     
                    quarterName=qunarterCount[poGrnData.reportedDate];
                    if(!poGrnDataMap.has(quarterName)){
                        const poGrnObj = new PoGrnForQty();                        
                        poGrnObj.poQty = poGrnData.poQty;                
                        poGrnObj.grnQty = poGrnData.grnQty;
                        poGrnDataMap.set(quarterName, poGrnObj);
                    }else{
                        poGrnDataMap.get(quarterName).poQty += poGrnData.poQty;     
                        poGrnDataMap.get(quarterName).grnQty += poGrnData.grnQty;
                    }
                }
            }
            // console.log(poGrnDataMap);
            // console.log(names);
            const dashboardPoGrnData = new PoGrnData();
            dashboardPoGrnData.poQty = [];
            dashboardPoGrnData.grnQty = [];            
            allNames.forEach(eachName => {
                const PoGrnForQty = poGrnDataMap.get(eachName); 
                dashboardPoGrnData.poQty.push(PoGrnForQty? PoGrnForQty.poQty : 0); 
                dashboardPoGrnData.grnQty.push(PoGrnForQty? PoGrnForQty.grnQty : 0); 
            })



            const dashboardData = new PoGrnDataResDto(names, dashboardPoGrnData);
            return new CommonResponse(true, 10000, 'Data Retrieved Successfully.', dashboardData);
                       
        } catch (error) {
            console.log(error);
            return error
        }
    }

     async getPoItemsDataForVendor(req:VenndorIdReq):Promise<CommonResponse>{
        try{
           const manager = getManager()
           const query = `SELECT po.purchase_order_id as purchaseOrderId,po.po_number as poNumber,po.status as poStatus,po.purchase_order_date as PoDate,po.unit_id as unitId,po.note as note,v.vendor_name as vendorName,i.item_name as itemName,poi.item_quantity as itemQuantity,poi.item_cost as itemCost,poi.tax_per as taxPercentage,poi.tax as taxAmount,poi.received_quantity as grnQty,poi.item_name as itemId,poi.purchase_order_items_id as poItemId,poi.asn_qty as asnQuantity,poi.sub_amount as totalAmount from ` + appSettings.procure_db + `.purchase_order_items poi
           left join ` + appSettings.procure_db + `.purchase_order po on po.purchase_order_id = poi.purchase_order_id left join ` + appSettings.masters_db + `.vendors v on v.vendor_id = po.vendor_name
           left join ` + appSettings.masters_db + `.items i on poi.item_name = i.item_id
           where po.purchase_order_id = ` + req.poId + ` and poi.purchase_order_items_id = ${req.poItemId} `
           const vendorData = await manager.query(query)
           if(vendorData && vendorData.length > 0){
             return new CommonResponse(true,1111,'Data Retreived',vendorData)
           }else{
            return new CommonResponse(false,1111,'No data found for the vendor')
           }
        }catch(error){
            return error
        }
    }

   
    async getPoDataForVendor(req:VenndorIdReq):Promise<CommonResponse>{
        try{
            const manager = getManager()
            const query = `select po.purchase_order_id as purchaseOrderId,po.po_number as poNumber,po.status as poStatus,po.purchase_order_date as PoDate,po.unit_id as unitId,po.note as note,v.vendor_name as vendorName ,po.total_amount as totalAmount ,po.supplier_status as supplierStatus,po.expected_delivery_date as etd,po.remarks as remarks,uc.unit_name AS unitName,UPPER(uc.village_name) AS villageName,UPPER(uc.mandal_name) AS mandalName,UPPER(uc.distirct_name) AS districtName,UPPER(uc.state_name) AS stateName,UPPER(uc.county_name) AS countryName,uc.fda_reg_number AS fdaRegNumber,DATE(po.expected_delivery_date) AS expectedDeliveryDate,po.billing_address,po.remarks AS remarks,po.note AS note,uc.postal_code as postalCode ,u.unit_name AS unitNamedel,UPPER(u.village_name) AS villageNameDel,UPPER(u.mandal_name) AS mandalNameDel,UPPER(u.distirct_name) AS districtNameDel,UPPER(u.state_name) AS stateNameDel,UPPER(u.county_name) AS countryNameDel,u.fda_reg_number AS fdaRegNumberDel,u.postal_code as postalCodeDel,po.is_acknowledgd as isAcknowledged  from `+ appSettings.procure_db + `.purchase_order po left join ` + appSettings.masters_db + `.vendors v on v.vendor_id = po.vendor_name
            left join `+appSettings.masters_db + `.unitcodes uc on uc.unit_code_id = po.delivery_address left join `+appSettings.masters_db+`.unitcodes u on u.unit_code_id=po.delivery_address where po.vendor_name = ` + req.vendorId 
            const vendorData = await manager.query(query)
            if(vendorData && vendorData.length > 0){
              return new CommonResponse(true,1111,'Data Retreived',vendorData)
            }else{
             return new CommonResponse(false,1111,'No data found for the vendor')
            }
        }catch(error){
            return error
        }
    }

    async updateSupplierStatus(req : POSupplierStatus):Promise<CommonResponse>{
        try{
            const update = await this.poRepo.update({purchaseOrderId:req.purchaseOrderId},{supplierStatus:req.supplierStatus})
            if(update.affected){
                if(req.supplierStatus == 'ASN'){
                    const mes  = ''
                    const message = await new MessageRequest('917036045967', "Advance Shipment note" , mes, "ERPX")
                    var messageStatus = await this.wpService.sendPersonalMessage(message);
                }else if(req.supplierStatus == 'Open'){
                    const mes  = ''
                    const message = await new MessageRequest('917036045967', "GRN Alert" , mes, "ERPX")
                    var messageStatus = await this.wpService.sendPersonalMessage(message);
                }
                return new CommonResponse(true,1111,'Updated Sucessfully')

            }else{
                return new CommonResponse(false,1111,'something went wrong')

            }
        }catch(error){
            throw error
        }
    }

    async getOpenPoNumbersForVendor(req: VenndorIdReq): Promise<PoNumbersResponseModel> {
        const query = `select `
        const poDTO: PoNumbersModel[] = [];
        const poNumbers: PoNumbersModel[] = await this.poRepository.find({
            select: ['purchaseOrderId', 'poNumber'],
            where: { status: In([StatusEnum.OPEN , StatusEnum.IN_PROGRESS]), vendorName: req.vendorId,supplierStatus:Not('ASN')},
            order: { 'createdAt': 'DESC' }
        });
        if (poNumbers && poNumbers.length > 0) {
            poNumbers.forEach(items => {
                poDTO.push(new PoNumbersModel(items.purchaseOrderId, items.poNumber));
            });
            const response = new PoNumbersResponseModel(true, 11108, "PO Numbers retrieved successfully", poDTO);
            return response;
        } else {
            throw new ErrorResponse(99998, 'Data not found');
        }
    }

    async getPackingStockData(req:PoStockrequest):Promise<CommonResponse>{
        try{
            const manager = getManager()
            let query = `SELECT i.item_name as itemName, SUM(IF(st.unit_id = 1 , st.physical_quantity , 0)) AS kkdValue ,  SUM(IF(st.unit_id = 2 , st.physical_quantity , 0)) AS unitOneValue ,SUM(IF(st.unit_id = 3 , st.physical_quantity , 0)) AS unitTwoValue,SUM(IF(st.unit_id = 5 , st.physical_quantity , 0)) AS headOfficeValue,
            (SUM(IF(st.unit_id = 1 , st.physical_quantity , 0)) + SUM(IF(st.unit_id = 2 , st.physical_quantity , 0)) + SUM(IF(st.unit_id = 3 , st.physical_quantity , 0))) AS total,st.item_sub_category_id AS itemSubcategoryId  from `+ appSettings.procure_db + `.stock st 
            LEFT JOIN ` + appSettings.masters_db + `.items i ON i.item_id = st.item_id WHERE st.stock_id > 0 `
            if (req.unitId && req.unitId != 5) {
                query = query + ' and st.unit_id = ' + req.unitId
            }
            if (req.itemSubcategoryId) {
                query = query + ' and st.item_sub_category_id = ' + req.itemSubcategoryId
            }
            if (req.saleOrderId) {
                query = query + ' and st.saleorder_id = ' + req.saleOrderId
            }
            query = query + ` GROUP BY st.item_id `
            const data = await manager.query(query)
            if( data.length > 0){
              return new CommonResponse(true,1111,'Data Retreived',data)
            }else{
             return new CommonResponse(false,1111,'No data found')
            }
        }catch(error){
            return error
        }
    }
    async getItemSubCatForPackingStock(req:UnitIdRequest):Promise<CommonResponse>{
        try{
            const manager = getManager()
            let query = `SELECT st.item_sub_category_id AS itemSubcategoryId ,isc.item_sub_category AS itemSubCat from `+ appSettings.procure_db + `.stock st 
            LEFT JOIN ` + appSettings.masters_db + `.item_sub_categories isc ON isc.item_sub_category_id = st.item_sub_category_id WHERE st.stock_id > 0 
            GROUP BY st.item_sub_category_id `
            if (req.unitId && req.unitId != 5) {
                query = query + ' and st.unit_id = ' + req.unitId
            }
            const data = await manager.query(query)
            if( data.length > 0){
              return new CommonResponse(true,1111,'Data Retreived',data)
            }else{
             return new CommonResponse(false,1111,'No data found')
            }
        }catch(error){
            return error
        }
    }
    async getPoNumForPackingStock(req:UnitIdRequest):Promise<CommonResponse>{
        try{
            const manager = getManager()
            let query = `SELECT st.saleorder_id as saleOrderId,snv.po_number as saleOrder from `+ appSettings.procure_db + `.stock st 
            LEFT JOIN ` + appSettings.sales_db + `.so_invoice_details snv ON snv.sale_order_id = st.saleorder_id WHERE st.stock_id > 0 
            GROUP BY st.saleorder_id `
            if (req.unitId && req.unitId != 5) {
                query = query + ' and st.unit_id = ' + req.unitId
            }
            const data = await manager.query(query)
            if( data.length > 0){
              return new CommonResponse(true,1111,'Data Retreived',data)
            }else{
             return new CommonResponse(false,1111,'No data found')
            }
        }catch(error){
            return error
        }
    }
    async getSupplyPerformanceReport(req:PoStockrequest): Promise<CommonResponse> {
        try {
            const manager = getManager()
            let query = `SELECT po.unit_id,v.vendor_name as vendor,po.po_number as poNumber,pi.purchase_order_id,
             uc.unit_name AS unit,item_category,i.item_name as itemName,pi.item_quantity as itemQuantity,pi.received_quantity as grnQty,pi.sale_order_id,
             isc.item_sub_category as itemSubCategory,COUNT(sinv.po_number) as poCount, po.created_at as createdDate ,pi.item_quantity as poQty,(((pi.item_quantity)/384933)*100) as materialOrdered,((pi.item_quantity) - (pi.received_quantity)) as balanceAndExcess, ((((pi.item_quantity) -(pi.received_quantity))/(pi.item_quantity))*100) as excessPercentage,(((pi.item_quantity)* s.unit_price)+(pi.tax)) AS totalAmount,(((((pi.item_quantity)* s.unit_price)+(pi.tax)) * ((((pi.item_quantity) - (pi.received_quantity))/(pi.item_quantity))*100) ) / 100) AS moneyLost,po.purchase_order_date as poDate FROM `  + poItemsTable + ` pi
                 LEFT JOIN `+ poTable + ` po ON po.purchase_order_id = pi.purchase_order_id
                 LEFT JOIN `+ soInvTable + ` sinv ON pi.sale_order_id = sinv.sale_order_id 
                 LEFT JOIN `+ unitCodesTable + ` uc ON uc.unit_code_id = po.unit_id
                 LEFT JOIN `+ itemsTable + ` i ON i.item_id = pi.item_name
                 LEFT JOIN `+ ietmSubCategoryTable + ` isc ON isc.item_sub_category_id = pi.item_sub_category_id
                 LEFT JOIN `+ vendorsTable + ` v ON v.vendor_id = po.vendor_name
                 LEFT JOIN `+ appSettings.procure_db + `.grn g ON g.po_id = pi.purchase_order_id 
                 LEFT JOIN `+ appSettings.procure_db + `.grn_items gi ON gi.po_id = pi.purchase_order_id 
                 LEFT JOIN `+ appSettings.procure_db + `.stock s ON s.item_id = pi.item_name 
                 WHERE pi.purchase_order_items_id > 0 and pi.status = 1`;
                 if (req.unitId && req.unitId != 5) {
                    query = query + ' and po.unit_id = ' + req.unitId;
                }
                if (req.itemSubcategoryId) {
                    query = query + ' and pi.item_sub_category_id = ' + req.itemSubcategoryId;
                }
                if(req.vendorId){
                    query = query + ' and po.vendor_name = ' + req.vendorId;
                }
                if(req.itemId){
                    query = query + ' and pi.item_name = ' + req.itemId;
                }
                if (req.fromDate != undefined) {
                    query = query + ' and date(po.purchase_order_date) >= "' + req.fromDate + '" and date(po.purchase_order_date) <= "' + req.toDate + '"';
                  }
            query = query + ` GROUP BY pi.purchase_order_id `
            const data = await manager.query(query);
            if (data.length > 0) {
                return new CommonResponse(true, 9999, 'data retrived', data)
            } else {
                return new CommonResponse(false, 1111, 'No data found', undefined)
            }
        } catch (err) {
            throw err
        }
    }

    async getItemSubCatForStockPerformance(req:UnitIdRequest):Promise<CommonResponse>{
        try{
            const manager = getManager()
            let query = `SELECT pi.item_sub_category_id AS itemSubcategoryId ,isc.item_sub_category AS itemSubCat from `+ appSettings.procure_db + `.purchase_order_items pi
            LEFT JOIN ` + appSettings.masters_db + `.item_sub_categories isc ON isc.item_sub_category_id = pi.item_sub_category_id
            LEFT JOIN `+ poTable + ` po ON po.purchase_order_id = pi.purchase_order_id WHERE pi.purchase_order_items_id > 0 GROUP BY pi.item_sub_category_id `
            if (req.unitId && req.unitId != 5) {
                query = query + ' and po.unit_id = ' + req.unitId
            }
            const data = await manager.query(query)
            if( data.length > 0){
              return new CommonResponse(true,1111,'Data Retreived',data)
            }else{
             return new CommonResponse(false,1111,'No data found')
            }
        }catch(error){
            return error
        }
    }

    async getVendorsForSupplyPerformance(req:UnitIdRequest):Promise<CommonResponse>{
        const manager = getManager()
        let query = `SELECT v.vendor_name AS vendor , po.vendor_name AS vendorId ,po.unit_id AS unitId FROM ` + appSettings.procure_db + `.purchase_order po LEFT JOIN ` + appSettings.masters_db + `.vendors v ON v.vendor_id = po.vendor_name WHERE po.vendor_name > 0 `
        if (req.unitId && req.unitId != 5) {
            query = query + ' and po.unit_id = ' + req.unitId
        }
        query = query + ` GROUP BY po.vendor_name `
        const data = await manager.query(query)
        if( data.length > 0){
          return new CommonResponse(true,1111,'Data Retreived',data)
        }else{
         return new CommonResponse(false,1111,'No data found')
        }
    }

    async getItemsForSupplyPerformance(req:UnitIdRequest):Promise<CommonResponse>{
        const manager = getManager()
        let query = `SELECT i.item_name AS itemName , pi.item_name AS itemId ,po.unit_id AS unitId FROM ` + appSettings.procure_db + `.purchase_order_items pi LEFT JOIN ` + appSettings.masters_db + `.items i ON i.item_id = pi.item_name LEFT JOIN ` + appSettings.procure_db + `.purchase_order po ON po.purchase_order_id = pi.purchase_order_id WHERE pi.item_name > 0 GROUP BY pi.item_name `
        if (req.unitId && req.unitId != 5) {
            query = query + ' and po.unit_id = ' + req.unitId
        }
        const data = await manager.query(query)
        if( data.length > 0){
          return new CommonResponse(true,1111,'Data Retreived',data)
        }else{
         return new CommonResponse(false,1111,'No data found')
        }
    }
    async StockmigUpdate():Promise<boolean>{
        const manager = getManager()
        const sostock = 'select assignableqty,location_id as locationId,item_id as itemId,sale_order_id as saleorderId from '+appSettings.procure_db+'.temp_so_data_mig';
        // `select location_id as locationId,item_id as itemId from stock_so_wise_final where unit_id = 3 and saleorder_id = 0`;
        const soStockData = await manager.query(sostock)
        console.log(soStockData)
        let saveFlag = true
        for(const record of soStockData){
            const assignableQtyQry = 'select * from '+appSettings.procure_db+'.stock_so_wise_final where location_id ='+record.locationId+' and item_id = '+record.itemId+' and unit_id = 3 and saleorder_id = 0';
            const assignableQty = await manager.query(assignableQtyQry)
            console.log(assignableQty+'ppppppp')
            if(assignableQty.length > 0){
                // if(assignableQty[0].assignableQty > 0){
                    console.log(assignableQty[0].assignableQty)
                    console.log(assignableQty)
                    const updateQty = 'update '+appSettings.procure_db+'.stock_so_wise_final set physical_quantity = physical_quantity-'+record.assignableqty+' where unit_id = 3 and saleorder_id = 0 and item_id = '+record.itemId+' and location_id ='+record.locationId
                    const updatestock = await manager.query(updateQty)
                    // if(!updatestock.affected){
                    //     console.log('yesssss')
                    //     saveFlag = false
                    //     break
                    // }else{
                    //     saveFlag = true
                    // }
                // }
            }else{
                console.log('assignableQtyoooo')

            }

        }
        // if(saveFlag){
            return true

        // }else{
        //     return false

        // }
    }
}